var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgSignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 993,
    height: 741,
    viewBox: "0 0 993 741",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_7223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M993 651.191H0V651.689H993V651.191Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.501 683.189H827.725V683.687H893.501V683.189Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.803 688.599H640.544V689.096H657.803V688.599Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.739 664.734H787.628V665.232H825.739V664.734Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.961 668.075H104.186V668.572H189.961V668.075Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.228 668.075H207.656V668.572H220.228V668.075Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.148 676.468H261.1V676.965H447.148V676.468Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.702 562.497H87.2053C80.9494 562.497 75.8652 557.406 75.8652 551.141V11.3553C75.8652 5.09101 80.9494 0 87.2053 0H470.702C476.958 0 482.042 5.09101 482.042 11.3553V551.141C482.042 557.406 476.958 562.497 470.702 562.497ZM87.2053 0.497169C81.2274 0.497169 76.3617 5.36942 76.3617 11.3553V551.141C76.3617 557.127 81.2274 561.999 87.2053 561.999H470.702C476.68 561.999 481.545 557.127 481.545 551.141V11.3553C481.545 5.36942 476.68 0.497169 470.702 0.497169H87.2053Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.274 562.497H516.777C510.521 562.497 505.437 557.406 505.437 551.141V11.3553C505.437 5.09101 510.521 0 516.777 0H900.274C906.53 0 911.614 5.09101 911.614 11.3553V551.141C911.614 557.406 906.53 562.497 900.274 562.497ZM516.777 0.497169C510.799 0.497169 505.934 5.36942 505.934 11.3553V551.141C505.934 557.127 510.799 561.999 516.777 561.999H900.274C906.252 561.999 911.117 557.127 911.117 551.141V11.3553C911.117 5.36942 906.252 0.497169 900.274 0.497169H516.777Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.236 94.8994H157.569V472.589H494.236V94.8994Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.236 100.985H164.183V465.887H494.236V100.985Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.377 294.682V269.028H183.685V251.945H193.436V226.311H195.879V251.945H205.63V269.028H212.939V294.682H226.364V302H232.461V330.08H233.673V289.789H237.327V315.423H240.981V254.391H243.424V280.025H253.175V271.474H256.849V236.075H264.158V200.677H266.601V205.549H316.588V190.893H325.108V134.732H328.782V190.893H340.956V205.549H345.842V278.812H371.442V256.837H362.922V253.158H371.442V247.053H395.83V190.893H401.927V182.361H431.18V190.893H434.855V269.028H448.26V304.446H455.569V276.366H461.666V269.028H475.071V243.394H482.399V226.311H490.939V200.677H494.236V465.887H164.183V294.682H176.377Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92 209.388H294.464V212.848H297.92V209.388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92 215.175H294.464V218.635H297.92V215.175Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92 238.383H294.464V241.843H297.92V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92 244.17H294.464V247.63H297.92V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92 249.977H294.464V253.437H297.92V249.977Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92 267.377H294.464V270.837H297.92V267.377Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.92 273.164H294.464V276.624H297.92V273.164Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.401 232.575H299.946V236.036H303.401V232.575Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.401 238.383H299.946V241.843H303.401V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.401 244.17H299.946V247.63H303.401V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.401 249.977H299.946V253.437H303.401V249.977Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.401 255.764H299.946V259.224H303.401V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.401 267.377H299.946V270.837H303.401V267.377Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.401 273.164H299.946V276.624H303.401V273.164Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 209.388H305.427V212.848H308.883V209.388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 215.175H305.427V218.635H308.883V215.175Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 220.981H305.427V224.442H308.883V220.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 226.769H305.427V230.229H308.883V226.769Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 232.575H305.427V236.036H308.883V232.575Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 238.383H305.427V241.843H308.883V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 244.17H305.427V247.63H308.883V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 249.977H305.427V253.437H308.883V249.977Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 255.764H305.427V259.224H308.883V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 261.57H305.427V265.031H308.883V261.57Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.883 273.164H305.427V276.624H308.883V273.164Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 209.388H310.928V212.848H314.384V209.388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 215.175H310.928V218.635H314.384V215.175Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 220.981H310.928V224.442H314.384V220.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 226.769H310.928V230.229H314.384V226.769Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 232.575H310.928V236.036H314.384V232.575Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 238.383H310.928V241.843H314.384V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 244.17H310.928V247.63H314.384V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.384 296.372H310.928V299.832H314.384V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 209.388H316.41V212.848H319.865V209.388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 215.175H316.41V218.635H319.865V215.175Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 220.981H316.41V224.442H319.865V220.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 226.769H316.41V230.229H319.865V226.769Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 232.575H316.41V236.036H319.865V232.575Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 238.383H316.41V241.843H319.865V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 244.17H316.41V247.63H319.865V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 249.977H316.41V253.437H319.865V249.977Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 284.759H316.41V288.219H319.865V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 290.565H316.41V294.026H319.865V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 296.372H316.41V299.832H319.865V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 302.159H316.41V305.619H319.865V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 325.367H316.41V328.827H319.865V325.367Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 209.388H321.891V212.848H325.347V209.388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 215.175H321.891V218.635H325.347V215.175Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 220.981H321.891V224.442H325.347V220.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 226.769H321.891V230.229H325.347V226.769Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 232.575H321.891V236.036H325.347V232.575Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 238.383H321.891V241.843H325.347V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 244.17H321.891V247.63H325.347V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 249.977H321.891V253.437H325.347V249.977Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 255.764H321.891V259.224H325.347V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 261.57H321.891V265.031H325.347V261.57Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 278.972H321.891V282.432H325.347V278.972Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 284.759H321.891V288.219H325.347V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 290.565H321.891V294.026H325.347V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 296.372H321.891V299.832H325.347V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 302.159H321.891V305.619H325.347V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.347 325.367H321.891V328.827H325.347V325.367Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 209.388H327.373V212.848H330.828V209.388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 215.175H327.373V218.635H330.828V215.175Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 220.981H327.373V224.442H330.828V220.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 226.769H327.373V230.229H330.828V226.769Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 232.575H327.373V236.036H330.828V232.575Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 238.383H327.373V241.843H330.828V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 244.17H327.373V247.63H330.828V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 249.977H327.373V253.437H330.828V249.977Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 255.764H327.373V259.224H330.828V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 261.57H327.373V265.031H330.828V261.57Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 267.377H327.373V270.837H330.828V267.377Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 273.164H327.373V276.624H330.828V273.164Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 278.972H327.373V282.432H330.828V278.972Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 284.759H327.373V288.219H330.828V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 290.565H327.373V294.026H330.828V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 296.372H327.373V299.832H330.828V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 302.159H327.373V305.619H330.828V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828 307.966H327.373V311.426H330.828V307.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 209.388H332.874V212.848H336.329V209.388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 215.175H332.874V218.635H336.329V215.175Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 220.981H332.874V224.442H336.329V220.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 226.769H332.874V230.229H336.329V226.769Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 232.575H332.874V236.036H336.329V232.575Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 238.383H332.874V241.843H336.329V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 244.17H332.874V247.63H336.329V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 249.977H332.874V253.437H336.329V249.977Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 255.764H332.874V259.224H336.329V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 261.57H332.874V265.031H336.329V261.57Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 278.972H332.874V282.432H336.329V278.972Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 284.759H332.874V288.219H336.329V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 290.565H332.874V294.026H336.329V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.329 296.372H332.874V299.832H336.329V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 209.388H338.355V212.848H341.811V209.388Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 215.175H338.355V218.635H341.811V215.175Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 220.981H338.355V224.442H341.811V220.981Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 226.769H338.355V230.229H341.811V226.769Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 232.575H338.355V236.036H341.811V232.575Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 238.383H338.355V241.843H341.811V238.383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 244.17H338.355V247.63H341.811V244.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 249.977H338.355V253.437H341.811V249.977Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 255.764H338.355V259.224H341.811V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 261.57H338.355V265.031H341.811V261.57Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 278.972H338.355V282.432H341.811V278.972Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 284.759H338.355V288.219H341.811V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.811 290.565H338.355V294.026H341.811V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 194.313H400.12V197.774H403.575V194.313Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 200.12H400.12V203.58H403.575V200.12Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 205.928H400.12V209.388H403.575V205.928Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 211.715H400.12V215.175H403.575V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 217.521H400.12V220.982H403.575V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 223.309H400.12V226.769H403.575V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 229.115H400.12V232.576H403.575V229.115Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 234.922H400.12V238.382H403.575V234.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 252.304H400.12V255.764H403.575V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.575 258.11H400.12V261.571H403.575V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 194.313H405.621V197.774H409.077V194.313Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 200.12H405.621V203.58H409.077V200.12Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 205.928H405.621V209.388H409.077V205.928Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 211.715H405.621V215.175H409.077V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 217.521H405.621V220.982H409.077V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 223.309H405.621V226.769H409.077V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 229.115H405.621V232.576H409.077V229.115Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 234.922H405.621V238.382H409.077V234.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.077 258.11H405.621V261.571H409.077V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.558 194.313H411.102V197.774H414.558V194.313Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.558 200.12H411.102V203.58H414.558V200.12Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.558 205.928H411.102V209.388H414.558V205.928Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.558 211.715H411.102V215.175H414.558V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.558 217.521H411.102V220.982H414.558V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.558 223.309H411.102V226.769H414.558V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.558 229.115H411.102V232.576H414.558V229.115Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.558 234.922H411.102V238.382H414.558V234.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 194.313H416.583V197.774H420.039V194.313Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 200.12H416.583V203.58H420.039V200.12Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 205.928H416.583V209.388H420.039V205.928Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 211.715H416.583V215.175H420.039V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 217.521H416.583V220.982H420.039V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 223.309H416.583V226.769H420.039V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 234.922H416.583V238.382H420.039V234.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 240.709H416.583V244.169H420.039V240.709Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 258.11H416.583V261.571H420.039V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 263.917H416.583V267.377H420.039V263.917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 269.704H416.583V273.164H420.039V269.704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 275.511H416.583V278.971H420.039V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 281.318H416.583V284.779H420.039V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 287.105H416.583V290.566H420.039V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.039 292.912H416.583V296.372H420.039V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 194.313H422.065V197.774H425.521V194.313Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 200.12H422.065V203.58H425.521V200.12Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 205.928H422.065V209.388H425.521V205.928Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 211.715H422.065V215.175H425.521V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 217.521H422.065V220.982H425.521V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 223.309H422.065V226.769H425.521V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 240.709H422.065V244.169H425.521V240.709Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 246.517H422.065V249.977H425.521V246.517Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 252.304H422.065V255.764H425.521V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 258.11H422.065V261.571H425.521V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 263.917H422.065V267.377H425.521V263.917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 269.704H422.065V273.164H425.521V269.704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 275.511H422.065V278.971H425.521V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 281.318H422.065V284.779H425.521V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 287.105H422.065V290.566H425.521V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 292.912H422.065V296.372H425.521V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 298.699H422.065V302.16H425.521V298.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.521 310.312H422.065V313.773H425.521V310.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 194.313H427.566V197.774H431.022V194.313Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 200.12H427.566V203.58H431.022V200.12Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 205.928H427.566V209.388H431.022V205.928Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 211.715H427.566V215.175H431.022V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 217.521H427.566V220.982H431.022V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 223.309H427.566V226.769H431.022V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 240.709H427.566V244.169H431.022V240.709Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 246.517H427.566V249.977H431.022V246.517Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 252.304H427.566V255.764H431.022V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 258.11H427.566V261.571H431.022V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 275.511H427.566V278.971H431.022V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 281.318H427.566V284.779H431.022V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 287.105H427.566V290.566H431.022V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 292.912H427.566V296.372H431.022V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 298.699H427.566V302.16H431.022V298.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 310.312H427.566V313.773H431.022V310.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.022 316.1H427.566V319.56H431.022V316.1Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 248.246H477.335V251.706H480.791V248.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 254.033H477.335V257.493H480.791V254.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 259.84H477.335V263.3H480.791V259.84Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 265.647H477.335V269.108H480.791V265.647Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 271.435H477.335V274.895H480.791V271.435Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 277.241H477.335V280.701H480.791V277.241Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 283.028H477.335V286.489H480.791V283.028Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 300.429H477.335V303.889H480.791V300.429Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 306.236H477.335V309.697H480.791V306.236Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.791 312.043H477.335V315.503H480.791V312.043Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.292 248.246H482.836V251.706H486.292V248.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.292 254.033H482.836V257.493H486.292V254.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.292 259.84H482.836V263.3H486.292V259.84Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.292 265.647H482.836V269.108H486.292V265.647Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.292 271.435H482.836V274.895H486.292V271.435Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.292 277.241H482.836V280.701H486.292V277.241Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.292 283.028H482.836V286.489H486.292V283.028Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.283 248.246H488.318V251.706H493.283V248.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.283 254.033H488.318V257.493H493.283V254.033Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.283 259.84H488.318V263.3H493.283V259.84Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.283 265.647H488.318V269.108H493.283V265.647Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.283 271.435H488.318V274.895H493.283V271.435Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.283 277.241H488.318V280.701H493.283V277.241Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.283 283.028H488.318V286.489H493.283V283.028Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 255.764H186.565V259.224H190.021V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 261.57H186.565V265.031H190.021V261.57Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 267.377H186.565V270.837H190.021V267.377Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 273.164H186.565V276.624H190.021V273.164Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 278.972H186.565V282.432H190.021V278.972Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 284.759H186.565V288.219H190.021V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 290.565H186.565V294.026H190.021V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 296.372H186.565V299.832H190.021V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 302.159H186.565V305.619H190.021V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 307.966H186.565V311.426H190.021V307.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 313.753H186.565V317.213H190.021V313.753Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 319.561H186.565V323.021H190.021V319.561Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 325.367H186.565V328.827H190.021V325.367Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 331.154H186.565V334.615H190.021V331.154Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 336.961H186.565V340.421H190.021V336.961Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 342.768H186.565V346.228H190.021V342.768Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 348.555H186.565V352.015H190.021V348.555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 354.362H186.565V357.823H190.021V354.362Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 360.149H186.565V363.61H190.021V360.149Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.021 365.956H186.565V369.416H190.021V365.956Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 255.764H192.046V259.224H195.502V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 261.57H192.046V265.031H195.502V261.57Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 267.377H192.046V270.837H195.502V267.377Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 273.164H192.046V276.624H195.502V273.164Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 278.972H192.046V282.432H195.502V278.972Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 284.759H192.046V288.219H195.502V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 290.565H192.046V294.026H195.502V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 296.372H192.046V299.832H195.502V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 302.159H192.046V305.619H195.502V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 307.966H192.046V311.426H195.502V307.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 313.753H192.046V317.213H195.502V313.753Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 319.561H192.046V323.021H195.502V319.561Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 325.367H192.046V328.827H195.502V325.367Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 331.154H192.046V334.615H195.502V331.154Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 336.961H192.046V340.421H195.502V336.961Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 342.768H192.046V346.228H195.502V342.768Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 348.555H192.046V352.015H195.502V348.555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.502 354.362H192.046V357.823H195.502V354.362Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 255.764H197.528V259.224H200.983V255.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 261.57H197.528V265.031H200.983V261.57Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 267.377H197.528V270.837H200.983V267.377Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 273.164H197.528V276.624H200.983V273.164Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 278.972H197.528V282.432H200.983V278.972Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 284.759H197.528V288.219H200.983V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 290.565H197.528V294.026H200.983V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 296.372H197.528V299.832H200.983V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 302.159H197.528V305.619H200.983V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 307.966H197.528V311.426H200.983V307.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 313.753H197.528V317.213H200.983V313.753Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 319.561H197.528V323.021H200.983V319.561Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 325.367H197.528V328.827H200.983V325.367Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 331.154H197.528V334.615H200.983V331.154Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 336.961H197.528V340.421H200.983V336.961Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 342.768H197.528V346.228H200.983V342.768Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 348.555H197.528V352.015H200.983V348.555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.983 354.362H197.528V357.823H200.983V354.362Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 298.103H166.03V301.563H169.485V298.103Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 303.89H166.03V307.35H169.485V303.89Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 309.696H166.03V313.157H169.485V309.696Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 315.483H166.03V318.944H169.485V315.483Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 321.29H166.03V324.75H169.485V321.29Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 327.098H166.03V330.558H169.485V327.098Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 332.885H166.03V336.345H169.485V332.885Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 338.691H166.03V342.152H169.485V338.691Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 344.479H166.03V347.939H169.485V344.479Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 350.285H166.03V353.745H169.485V350.285Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 356.092H166.03V359.552H169.485V356.092Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 361.879H166.03V365.339H169.485V361.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.485 367.687H166.03V371.147H169.485V367.687Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 298.103H171.511V301.563H174.967V298.103Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 303.89H171.511V307.35H174.967V303.89Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 309.696H171.511V313.157H174.967V309.696Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 315.483H171.511V318.944H174.967V315.483Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 321.29H171.511V324.75H174.967V321.29Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 327.098H171.511V330.558H174.967V327.098Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 332.885H171.511V336.345H174.967V332.885Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 338.691H171.511V342.152H174.967V338.691Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 344.479H171.511V347.939H174.967V344.479Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 350.285H171.511V353.745H174.967V350.285Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 356.092H171.511V359.552H174.967V356.092Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 361.879H171.511V365.339H174.967V361.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.967 367.687H171.511V371.147H174.967V367.687Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 298.103H177.012V301.563H180.468V298.103Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 303.89H177.012V307.35H180.468V303.89Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 309.696H177.012V313.157H180.468V309.696Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 315.483H177.012V318.944H180.468V315.483Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 321.29H177.012V324.75H180.468V321.29Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 327.098H177.012V330.558H180.468V327.098Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 332.885H177.012V336.345H180.468V332.885Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 338.691H177.012V342.152H180.468V338.691Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 344.479H177.012V347.939H180.468V344.479Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 350.285H177.012V353.745H180.468V350.285Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 356.092H177.012V359.552H180.468V356.092Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 361.879H177.012V365.339H180.468V361.879Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 367.687H177.012V371.147H180.468V367.687Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.468 373.493H177.012V376.953H180.468V373.493Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 299.833H207.498V303.293H210.953V299.833Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 305.619H207.498V309.079H210.953V305.619Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 311.427H207.498V314.887H210.953V311.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 317.214H207.498V320.674H210.953V317.214Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 323.021H207.498V326.481H210.953V323.021Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 328.827H207.498V332.287H210.953V328.827Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 334.614H207.498V338.075H210.953V334.614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 340.422H207.498V343.882H210.953V340.422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 346.208H207.498V349.668H210.953V346.208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 352.016H207.498V355.476H210.953V352.016Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.953 369.416H207.498V372.876H210.953V369.416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 299.833H212.979V303.293H216.435V299.833Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 305.619H212.979V309.079H216.435V305.619Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 311.427H212.979V314.887H216.435V311.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 317.214H212.979V320.674H216.435V317.214Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 323.021H212.979V326.481H216.435V323.021Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 328.827H212.979V332.287H216.435V328.827Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 334.614H212.979V338.075H216.435V334.614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 340.422H212.979V343.882H216.435V340.422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 346.208H212.979V349.668H216.435V346.208Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 363.609H212.979V367.07H216.435V363.609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 369.416H212.979V372.876H216.435V369.416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 299.833H218.46V303.293H221.916V299.833Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 305.619H218.46V309.079H221.916V305.619Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 311.427H218.46V314.887H221.916V311.427Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 317.214H218.46V320.674H221.916V317.214Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 323.021H218.46V326.481H221.916V323.021Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 328.827H218.46V332.287H221.916V328.827Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 334.614H218.46V338.075H221.916V334.614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 340.422H218.46V343.882H221.916V340.422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 357.822H218.46V361.283H221.916V357.822Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 363.609H218.46V367.07H221.916V363.609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.916 369.416H218.46V372.876H221.916V369.416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 211.715H269.46V215.175H272.916V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 217.521H269.46V220.982H272.916V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 223.309H269.46V226.769H272.916V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 229.115H269.46V232.576H272.916V229.115Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 234.922H269.46V238.382H272.916V234.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 240.709H269.46V244.169H272.916V240.709Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 246.517H269.46V249.977H272.916V246.517Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 252.304H269.46V255.764H272.916V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 258.11H269.46V261.571H272.916V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 263.917H269.46V267.377H272.916V263.917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 269.704H269.46V273.164H272.916V269.704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 275.511H269.46V278.971H272.916V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 281.318H269.46V284.779H272.916V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 287.105H269.46V290.566H272.916V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 292.912H269.46V296.372H272.916V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 298.699H269.46V302.16H272.916V298.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 304.506H269.46V307.966H272.916V304.506Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 316.1H269.46V319.56H272.916V316.1Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 321.907H269.46V325.368H272.916V321.907Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 327.694H269.46V331.155H272.916V327.694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 333.501H269.46V336.961H272.916V333.501Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.916 339.308H269.46V342.768H272.916V339.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 211.715H274.942V215.175H278.398V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 217.521H274.942V220.982H278.398V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 223.309H274.942V226.769H278.398V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 229.115H274.942V232.576H278.398V229.115Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 234.922H274.942V238.382H278.398V234.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 240.709H274.942V244.169H278.398V240.709Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 246.517H274.942V249.977H278.398V246.517Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 252.304H274.942V255.764H278.398V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 258.11H274.942V261.571H278.398V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 263.917H274.942V267.377H278.398V263.917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 269.704H274.942V273.164H278.398V269.704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 275.511H274.942V278.971H278.398V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 281.318H274.942V284.779H278.398V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 287.105H274.942V290.566H278.398V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 292.912H274.942V296.372H278.398V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 298.699H274.942V302.16H278.398V298.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 333.501H274.942V336.961H278.398V333.501Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.398 339.308H274.942V342.768H278.398V339.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 211.715H280.443V215.175H283.899V211.715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 217.521H280.443V220.982H283.899V217.521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 223.309H280.443V226.769H283.899V223.309Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 229.115H280.443V232.576H283.899V229.115Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 234.922H280.443V238.382H283.899V234.922Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 240.709H280.443V244.169H283.899V240.709Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 246.517H280.443V249.977H283.899V246.517Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 252.304H280.443V255.764H283.899V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 258.11H280.443V261.571H283.899V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 263.917H280.443V267.377H283.899V263.917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 269.704H280.443V273.164H283.899V269.704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 275.511H280.443V278.971H283.899V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 281.318H280.443V284.779H283.899V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 287.105H280.443V290.566H283.899V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 292.912H280.443V296.372H283.899V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 298.699H280.443V302.16H283.899V298.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 310.312H280.443V313.773H283.899V310.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 316.1H280.443V319.56H283.899V316.1Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 321.907H280.443V325.368H283.899V321.907Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 327.694H280.443V331.155H283.899V327.694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.899 339.308H280.443V342.768H283.899V339.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 284.759H249.541V288.219H252.997V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 290.565H249.541V294.026H252.997V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 296.372H249.541V299.832H252.997V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 302.159H249.541V305.619H252.997V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 307.966H249.541V311.426H252.997V307.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 313.753H249.541V317.213H252.997V313.753Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 319.561H249.541V323.021H252.997V319.561Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 331.154H249.541V334.615H252.997V331.154Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 336.961H249.541V340.421H252.997V336.961Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 342.768H249.541V346.228H252.997V342.768Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 348.555H249.541V352.015H252.997V348.555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 354.362H249.541V357.823H252.997V354.362Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 360.149H249.541V363.61H252.997V360.149Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 365.956H249.541V369.416H252.997V365.956Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 371.763H249.541V375.223H252.997V371.763Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 284.759H255.042V288.219H258.498V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 290.565H255.042V294.026H258.498V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 296.372H255.042V299.832H258.498V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 302.159H255.042V305.619H258.498V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 307.966H255.042V311.426H258.498V307.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 313.753H255.042V317.213H258.498V313.753Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 331.154H255.042V334.615H258.498V331.154Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 336.961H255.042V340.421H258.498V336.961Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 342.768H255.042V346.228H258.498V342.768Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 348.555H255.042V352.015H258.498V348.555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 354.362H255.042V357.823H258.498V354.362Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 360.149H255.042V363.61H258.498V360.149Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 365.956H255.042V369.416H258.498V365.956Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.498 371.763H255.042V375.223H258.498V371.763Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 284.759H260.523V288.219H263.979V284.759Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 290.565H260.523V294.026H263.979V290.565Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 296.372H260.523V299.832H263.979V296.372Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 302.159H260.523V305.619H263.979V302.159Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 307.966H260.523V311.426H263.979V307.966Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 313.753H260.523V317.213H263.979V313.753Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 325.367H260.523V328.827H263.979V325.367Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 331.154H260.523V334.615H263.979V331.154Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 336.961H260.523V340.421H263.979V336.961Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 342.768H260.523V346.228H263.979V342.768Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 348.555H260.523V352.015H263.979V348.555Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 354.362H260.523V357.823H263.979V354.362Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 360.149H260.523V363.61H263.979V360.149Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 365.956H260.523V369.416H263.979V365.956Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.979 371.763H260.523V375.223H263.979V371.763Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 252.304H376.148V255.764H379.604V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 258.11H376.148V261.571H379.604V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 263.917H376.148V267.377H379.604V263.917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 269.704H376.148V273.164H379.604V269.704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 275.511H376.148V278.971H379.604V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 281.318H376.148V284.779H379.604V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 287.105H376.148V290.566H379.604V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 292.912H376.148V296.372H379.604V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 298.699H376.148V302.16H379.604V298.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 304.506H376.148V307.966H379.604V304.506Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 310.312H376.148V313.773H379.604V310.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 316.1H376.148V319.56H379.604V316.1Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 321.907H376.148V325.368H379.604V321.907Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 333.501H376.148V336.961H379.604V333.501Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 339.308H376.148V342.768H379.604V339.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 345.095H376.148V348.555H379.604V345.095Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 350.901H376.148V354.362H379.604V350.901Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 362.496H376.148V365.956H379.604V362.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 368.303H376.148V371.763H379.604V368.303Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.604 374.09H376.148V377.55H379.604V374.09Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 252.304H381.63V255.764H385.086V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 258.11H381.63V261.571H385.086V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 263.917H381.63V267.377H385.086V263.917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 269.704H381.63V273.164H385.086V269.704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 275.511H381.63V278.971H385.086V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 281.318H381.63V284.779H385.086V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 287.105H381.63V290.566H385.086V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 292.912H381.63V296.372H385.086V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 298.699H381.63V302.16H385.086V298.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 304.506H381.63V307.966H385.086V304.506Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 310.312H381.63V313.773H385.086V310.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 316.1H381.63V319.56H385.086V316.1Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 321.907H381.63V325.368H385.086V321.907Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 339.308H381.63V342.768H385.086V339.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 345.095H381.63V348.555H385.086V345.095Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 356.688H381.63V360.149H385.086V356.688Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 362.496H381.63V365.956H385.086V362.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 368.303H381.63V371.763H385.086V368.303Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.086 374.09H381.63V377.55H385.086V374.09Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 252.304H387.111V255.764H390.567V252.304Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 258.11H387.111V261.571H390.567V258.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 263.917H387.111V267.377H390.567V263.917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 269.704H387.111V273.164H390.567V269.704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 275.511H387.111V278.971H390.567V275.511Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 281.318H387.111V284.779H390.567V281.318Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 287.105H387.111V290.566H390.567V287.105Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 292.912H387.111V296.372H390.567V292.912Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 298.699H387.111V302.16H390.567V298.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 304.506H387.111V307.966H390.567V304.506Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 310.312H387.111V313.773H390.567V310.312Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 316.1H387.111V319.56H390.567V316.1Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 321.907H387.111V325.368H390.567V321.907Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 327.694H387.111V331.155H390.567V327.694Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 339.308H387.111V342.768H390.567V339.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 350.901H387.111V354.362H390.567V350.901Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 356.688H387.111V360.149H390.567V356.688Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 362.496H387.111V365.956H390.567V362.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 368.303H387.111V371.763H390.567V368.303Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.567 374.09H387.111V377.55H390.567V374.09Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 285.375H353.786V288.835H357.242V285.375Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 291.182H353.786V294.642H357.242V291.182Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 296.969H353.786V300.429H357.242V296.969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 302.775H353.786V306.236H357.242V302.775Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 308.583H353.786V312.043H357.242V308.583Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 314.37H353.786V317.83H357.242V314.37Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 331.771H353.786V335.231H357.242V331.771Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 337.577H353.786V341.037H357.242V337.577Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 343.364H353.786V346.825H357.242V343.364Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 349.172H353.786V352.632H357.242V349.172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 354.959H353.786V358.419H357.242V354.959Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 360.766H353.786V364.226H357.242V360.766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.242 366.572H353.786V370.033H357.242V366.572Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 285.375H359.288V288.835H362.743V285.375Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 291.182H359.288V294.642H362.743V291.182Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 296.969H359.288V300.429H362.743V296.969Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 302.775H359.288V306.236H362.743V302.775Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 308.583H359.288V312.043H362.743V308.583Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 314.37H359.288V317.83H362.743V314.37Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 331.771H359.288V335.231H362.743V331.771Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 337.577H359.288V341.037H362.743V337.577Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 343.364H359.288V346.825H362.743V343.364Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 349.172H359.288V352.632H362.743V349.172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 354.959H359.288V358.419H362.743V354.959Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 360.766H359.288V364.226H362.743V360.766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.743 372.359H359.288V375.82H362.743V372.359Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.216 95.7544H487.364V472.588H494.216V95.7544Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.093 95.7544H378.293V472.588H384.093V95.7544Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.021 95.7544H269.222V472.588H275.021V95.7544Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.972 110.67C700.514 110.67 713.113 98.0532 713.113 82.4901C713.113 66.9269 700.514 54.3105 684.972 54.3105C669.429 54.3105 656.83 66.9269 656.83 82.4901C656.83 98.0532 669.429 110.67 684.972 110.67Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.883 82.4899C708.883 95.7146 698.179 106.453 684.952 106.453C671.725 106.453 661.021 95.7345 661.021 82.4899C661.021 69.2453 671.725 58.5264 684.952 58.5264C698.179 58.5264 708.883 69.2453 708.883 82.4899Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.84 66.0635V82.8081L672.758 76.5239",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.84 66.0635V82.8081L672.758 76.5239",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.422 127.971H701.019V292.395H825.422V127.971Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.34 145.472V217.76L772.098 216.129L775.394 145.472H743.34Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.616 159.452H810.864L810.487 222.732L787.568 223.09L766.616 159.452Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.54 150.125H735.178L731.106 206.583L716.549 210.183L723.54 150.125Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.781 312.46H682.787V161.36L558.781 161.36V312.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.161 275.034L652.322 210.879L581.819 199.245L587.161 275.034Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.753 259.821L653.97 210.641L604.916 222.712L601.341 260.338L650.753 259.821Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.567 204.638C608.299 196.895 608.299 184.341 600.567 176.598C592.834 168.855 580.297 168.855 572.564 176.598C564.832 184.341 564.832 196.895 572.564 204.638C580.297 212.381 592.834 212.381 600.567 204.638Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.338 277.361C644.338 272.051 648.648 267.735 653.95 267.735C659.253 267.735 663.562 272.051 663.562 277.361C663.562 282.67 659.253 286.986 653.95 286.986C648.648 286.986 644.338 282.67 644.338 277.361Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.666 294.263L623.922 277.36L647.237 258.109L651.666 294.263Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.917 180.571H613.456V301.224H618.917V180.571Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.149 180.571H664.099V295.895H671.149V180.571Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.279 260.337H571.233V296.431H607.279V260.337Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.021 513.933H686.699V632.517H817.021V513.933Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.94 503.473H820.556V650.734H836.94V503.473Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.138 524.99H707.453V567.528H718.138V524.99Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.406 524.99H751.721V567.528H762.406V524.99Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.802 528.669H718.118V567.528H728.802V528.669Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.721 528.669H741.036V567.528H751.721V528.669Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.036 524.99H734.145V567.528H741.036V524.99Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.145 528.669H728.803V567.528H734.145V528.669Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.09 524.99H762.406V567.528H773.09V524.99Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.775 528.669H773.09V567.528H783.775V528.669Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.693 528.669H796.009V567.528H806.693V528.669Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.989 524.99H789.098V567.528H795.989V524.99Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.098 528.669H783.755V567.528H789.098V528.669Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.016 526.223H806.674V567.527H812.016V526.223Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.351 625.955H812.036V585.406H801.351V625.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.063 625.955H767.748V585.406H757.063V625.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.646 625.936H801.331V589.066H790.646V625.936Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.728 625.936H778.413V589.066H767.728V625.936Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.433 625.955H785.324V585.406H778.433V625.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.324 625.936H790.667V589.066H785.324V625.936Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.379 625.955H757.063V585.406H746.379V625.955Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.694 625.936H746.378V589.066H735.694V625.936Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.776 625.936H723.46V589.066H712.776V625.936Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.48 625.955H730.372V585.406H723.48V625.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.562 625.955H707.453V585.406H700.562V625.955Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.352 625.936H735.694V589.066H730.352V625.936Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.433 625.936H712.775V586.619H707.433V625.936Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.365 503.473H682.568V641.248H811.996V650.734H820.734V503.473H816.365ZM811.996 625.935H690.81V576.318H811.996V625.935ZM811.996 567.568H690.81V518.766H811.996V567.568Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.18 632.498H686.501V513.913H556.18V632.498Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.184 650.734H577.569V639.538H561.184V650.734Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.407 567.528H682.092V524.991H671.407V567.528Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.139 567.528H637.824V524.991H627.139V567.528Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.742 567.528H671.427V528.67H660.742V567.528Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.824 567.528H648.509V528.67H637.824V567.528Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.508 567.528H655.4V524.991H648.508V567.528Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.4 567.528H660.742V528.67H655.4V567.528Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.505 567.528H634.189V524.991H623.505V567.528Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.82 567.528H623.505V528.67H612.82V567.528Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.902 567.528H600.586V528.67H589.902V567.528Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.606 567.528H607.498V524.991H600.606V567.528Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.478 567.528H612.82V528.67H607.478V567.528Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.579 567.528H589.921V526.224H584.579V567.528Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.239 585.386H579.555V625.935H590.239V585.386Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.507 585.386H623.823V625.935H634.507V585.386Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.924 589.085H590.239V625.955H600.924V589.085Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.842 589.085H613.158V625.955H623.842V589.085Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.138 585.386H606.247V625.935H613.138V585.386Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.247 589.085H600.904V625.955H606.247V589.085Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.162 585.386H627.477V625.935H638.162V585.386Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.826 589.085H638.142V625.955H648.826V589.085Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.745 589.085H661.06V625.955H671.745V589.085Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.06 585.386H654.169V625.935H661.06V585.386Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.569 585.386H675.677V625.935H682.569V585.386Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.169 589.085H648.826V625.955H654.169V589.085Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.087 586.639H671.745V625.955H677.087V586.639Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.446 503.473V650.734H561.184V641.248H690.612V503.473H552.446ZM561.184 576.338H682.37V625.955H561.184V576.338ZM561.184 518.785H682.37V567.588H561.184V518.785Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.5 741C709.166 741 881.566 730.921 881.566 718.488C881.566 706.055 709.166 695.977 496.5 695.977C283.834 695.977 111.435 706.055 111.435 718.488C111.435 730.921 283.834 741 496.5 741Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.751 631.742C758.751 631.742 743.36 613.387 733.489 621.958C723.619 630.529 728.624 648.666 739.984 649.262C751.344 649.839 758.732 643.515 758.732 643.515V631.742H758.751Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M758.751 631.742C758.751 631.742 743.36 613.387 733.489 621.958C723.619 630.529 728.624 648.666 739.984 649.262C751.344 649.839 758.732 643.515 758.732 643.515V631.742H758.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.568 585.207C821.568 585.207 834.497 571.644 842.501 573.951C850.504 576.258 849.67 608.653 824.845 595.548L821.568 585.226V585.207Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M821.568 585.207C821.568 585.207 834.497 571.644 842.501 573.951C850.504 576.258 849.67 608.653 824.845 595.548L821.568 585.226V585.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.374 686.411C775.374 686.411 732.874 628.202 767.371 616.41C801.867 604.617 808.024 663.243 798.173 679.57C788.323 695.897 775.394 686.411 775.394 686.411H775.374Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.075 567.229C795.075 567.229 821.429 505.938 782.385 504.089C743.34 502.24 739.09 564.863 784.013 573.951L795.075 567.229Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M775.374 686.411C775.374 686.411 732.874 628.202 767.371 616.41C801.867 604.617 808.024 663.243 798.173 679.57C788.323 695.897 775.394 686.411 775.394 686.411H775.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M795.075 567.229C795.075 567.229 821.429 505.938 782.385 504.089C743.34 502.24 739.09 564.863 784.013 573.951L795.075 567.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.721 617.403C785.721 617.403 772.912 563.291 797.538 558.976C822.164 554.66 846.493 603.562 795.532 628.142C795.532 628.142 786.794 622.713 785.721 617.423V617.403Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M785.721 617.403C785.721 617.403 772.912 563.291 797.538 558.976C822.164 554.66 846.493 603.562 795.532 628.142C795.532 628.142 786.794 622.713 785.721 617.423V617.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.79 678.157H816.127L810.169 723.877H750.748L744.79 678.157Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.888 562.834C778.135 560.129 774.898 556.769 772.018 553.129C769.138 549.47 766.775 545.393 765.027 541.038C763.279 536.683 762.445 531.95 762.485 527.257C762.406 522.524 763.855 517.97 765.683 513.773C765.444 514.907 765.186 516.021 764.908 517.134L764.511 518.785C764.431 519.342 764.392 519.918 764.332 520.475C764.213 521.609 764.054 522.722 763.955 523.836L764.014 527.217C764.332 531.691 765.166 536.126 766.874 540.302C768.523 544.479 770.727 548.436 773.249 552.214C774.5 554.104 775.871 555.933 777.34 557.664C778.75 559.473 780.3 561.144 781.888 562.814V562.834Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.534 510.254C774.758 510.612 776.864 511.487 778.929 512.441C780.915 513.535 782.861 514.748 784.569 516.299C788.065 519.283 790.706 523.2 792.513 527.416C794.281 531.672 795.016 536.246 795.234 540.78C795.274 543.047 795.095 545.314 795.016 547.561C794.619 549.789 794.301 552.016 793.864 554.204C793.864 551.956 793.983 549.729 794.043 547.502C793.923 545.274 793.923 543.067 793.705 540.88C793.288 538.712 793.268 536.485 792.613 534.396C792.335 533.342 792.156 532.269 791.798 531.234L790.666 528.172C787.389 520.177 780.935 513.456 772.534 510.254Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.404 562.834C808.143 564.883 812.81 569.636 815.352 575.283C816.643 578.107 817.477 581.15 817.775 584.232C817.934 584.988 817.894 585.784 817.894 586.579C817.875 587.375 817.934 588.17 817.835 588.946C817.577 590.497 817.438 592.068 816.901 593.539C816.087 596.562 814.637 599.326 813.168 602.011C811.519 604.596 809.831 607.162 807.806 609.449C803.893 614.122 799.484 618.338 794.599 621.918C796.763 619.81 798.888 617.682 800.874 615.415C802.9 613.188 804.846 610.901 806.614 608.494C810.169 603.721 813.386 598.591 814.995 592.963C815.511 591.591 815.63 590.139 815.908 588.707C816.028 587.991 815.948 587.275 815.988 586.559C815.988 585.843 816.028 585.127 815.908 584.392C815.73 581.448 814.955 578.585 813.942 575.84C812.89 573.096 811.341 570.55 809.374 568.343C807.448 566.096 805.085 564.187 802.404 562.814V562.834Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.075 567.229C796.525 571.207 797.419 575.363 797.816 579.619C798.054 581.747 797.995 583.914 797.776 586.082C797.538 588.23 796.962 590.437 795.75 592.426C793.407 595.767 792.613 599.764 792.156 603.901C791.917 605.949 791.858 608.037 791.858 610.125C791.798 612.213 791.898 614.321 791.997 616.429C790.984 612.333 790.527 608.077 790.627 603.801C790.666 601.653 790.924 599.506 791.421 597.378C791.719 596.324 792.017 595.27 792.493 594.256C792.831 593.241 793.645 592.207 794.062 591.372C795.095 589.781 795.631 587.812 795.909 585.824C796.227 583.835 796.307 581.767 796.287 579.698C796.287 577.63 796.128 575.542 795.889 573.474C795.711 571.386 795.393 569.318 795.075 567.229Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.757 621.958C778.85 622.276 779.704 623.111 780.419 623.967C781.153 624.822 781.729 625.796 782.305 626.771C783.358 628.759 784.212 630.828 784.986 632.916C786.516 637.112 787.588 641.447 788.521 645.782C789.415 650.138 790.15 654.513 790.607 658.927C791.083 663.322 791.5 667.757 791.302 672.212C790.984 670.024 790.646 667.837 790.249 665.669C789.892 663.501 789.514 661.314 789.097 659.166C788.263 654.831 787.489 650.515 786.575 646.22C785.701 641.904 784.688 637.649 783.537 633.413C782.961 631.305 782.285 629.217 781.431 627.208C781.014 626.214 780.577 625.2 779.982 624.305C779.406 623.41 778.75 622.495 777.757 621.978V621.958Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.683 623.827C764.531 627.804 763.935 631.861 763.677 635.898C763.458 639.935 763.736 643.992 764.551 647.93C765.325 651.867 766.636 655.706 768.562 659.265C770.35 662.905 772.832 666.146 775.374 669.408C774.6 668.731 773.845 668.035 773.09 667.3C772.355 666.564 771.521 665.907 770.906 665.072C769.595 663.461 768.205 661.871 767.212 660.021C766.02 658.271 765.246 656.322 764.372 654.393C763.975 653.419 763.716 652.384 763.379 651.39C763.021 650.396 762.803 649.362 762.604 648.328C761.77 644.191 761.591 639.935 762.128 635.779C762.644 631.623 763.796 627.546 765.663 623.847L765.683 623.827Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.598 591.809C833.902 591.133 835.987 590.616 837.914 589.781C838.887 589.403 839.78 588.866 840.674 588.289C841.588 587.712 842.342 586.957 843.276 586.161C843.077 587.334 842.561 588.528 841.707 589.442C840.893 590.377 839.84 591.113 838.688 591.61C837.536 592.067 836.345 592.366 835.133 592.386C833.922 592.425 832.71 592.286 831.598 591.809Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.957 582.861C829.513 581.747 830.347 580.852 831.3 580.076C832.253 579.301 833.365 578.684 834.597 578.326C835.828 577.988 837.179 577.909 838.45 578.287C839.721 578.645 840.773 579.52 841.429 580.534C840.237 580.156 839.224 579.838 838.172 579.818C837.139 579.818 836.146 579.937 835.133 580.235C834.12 580.494 833.127 580.951 832.114 581.389L828.957 582.861Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.721 634.486C749.06 632.438 746.597 630.35 743.896 628.838C742.565 628.043 741.155 627.466 739.705 627.287C738.256 627.088 736.746 627.407 735.197 628.142C736.19 626.77 737.898 625.796 739.745 625.736C741.592 625.617 743.36 626.253 744.869 627.108C746.378 627.983 747.709 629.077 748.861 630.33C750.013 631.583 751.006 632.955 751.721 634.506V634.486Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.721 643.515C749.854 644.231 747.908 644.609 745.942 644.788C743.956 644.987 741.95 644.907 739.964 644.609C737.978 644.291 735.952 643.595 734.264 642.302C732.556 641.049 731.444 639.001 731.483 636.992C732.298 638.842 733.569 640.154 735.118 641.009C736.687 641.845 738.454 642.382 740.281 642.66C743.956 643.276 747.769 643.336 751.721 643.535V643.515Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.881 684.104C628.49 681.379 626.226 677.303 623.048 677.243C624.438 673.345 623.048 668.632 619.811 666.067C619.394 665.748 618.937 665.45 618.401 665.45C617.845 665.45 617.348 665.788 616.891 666.106C613.912 668.254 610.933 670.382 607.954 672.53C607.279 673.027 606.564 673.544 606.187 674.28C604.36 677.82 610.933 682.354 608.232 685.277C607.458 686.113 606.207 686.292 605.234 686.888C603.109 688.221 602.85 691.144 601.857 693.451C600.864 695.758 597.409 697.547 596.098 695.42C597.071 693.212 594.112 691.303 591.729 691.025C589.365 690.746 586.823 690.607 585.493 688.36C582.097 691.343 574.47 683.03 574.649 679.669C571.849 679.888 569.942 682.513 569.327 685.138C568.691 687.863 569.088 690.706 569.049 693.491C568.969 698.92 567.222 704.229 567.301 709.658C567.38 713.874 569.009 718.568 572.862 720.258C574.729 721.073 576.814 721.073 578.84 721.054C593.496 720.954 608.133 720.875 622.79 720.775C623.842 720.775 624.955 720.755 625.888 720.258C627.874 719.224 628.291 716.619 628.47 714.392C629.264 704.826 630.039 695.28 630.833 685.715C629.503 685.178 628.172 684.641 626.861 684.084L626.881 684.104Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M626.881 684.104C628.49 681.379 626.226 677.303 623.048 677.243C624.438 673.345 623.048 668.632 619.811 666.067C619.394 665.748 618.937 665.45 618.401 665.45C617.845 665.45 617.348 665.788 616.891 666.106C613.912 668.254 610.933 670.382 607.954 672.53C607.279 673.027 606.564 673.544 606.187 674.28C604.36 677.82 610.933 682.354 608.232 685.277C607.458 686.113 606.207 686.292 605.234 686.888C603.109 688.221 602.85 691.144 601.857 693.451C600.864 695.758 597.409 697.547 596.098 695.42C597.071 693.212 594.112 691.303 591.729 691.025C589.365 690.746 586.823 690.607 585.493 688.36C582.097 691.343 574.47 683.03 574.649 679.669C571.849 679.888 569.942 682.513 569.327 685.138C568.691 687.863 569.088 690.706 569.049 693.491C568.969 698.92 567.222 704.229 567.301 709.658C567.38 713.874 569.009 718.568 572.862 720.258C574.729 721.073 576.814 721.073 578.84 721.054C593.496 720.954 608.133 720.875 622.79 720.775C623.842 720.775 624.955 720.755 625.888 720.258C627.874 719.224 628.291 716.619 628.47 714.392C629.264 704.826 630.039 695.28 630.833 685.715C629.503 685.178 628.172 684.641 626.861 684.084L626.881 684.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.463 637.589H561.283L561.839 644.49L562.237 649.422L563.269 662.249L563.865 669.607L564.659 679.411L564.997 683.607L565.116 684.86L565.513 689.792L566.05 696.553L566.387 700.75L566.745 705.025L567.142 709.957L567.44 713.696L567.777 717.892L567.916 719.721H630.495L630.634 717.892L630.972 713.696L631.27 709.917L631.667 704.985L632.025 700.73L632.362 696.534L632.898 689.752L633.296 684.82L633.395 683.567L633.733 679.371L634.527 669.567L635.123 662.229L636.155 649.402L636.553 644.47L637.109 637.569H629.443L629.463 637.589ZM633.574 642.104L632.263 640.791H633.693L633.574 642.104ZM633.236 646.3L633.117 647.97L627.02 654.075L620.009 647.055L626.265 640.791H627.735L633.236 646.3ZM631.468 668.155L627 672.63L619.989 665.61L627 658.609L631.846 663.462L631.468 668.155ZM566.586 663.462L571.432 658.609L578.442 665.61L571.432 672.63L566.983 668.155L566.606 663.462H566.586ZM624.736 656.342L617.725 663.362L610.715 656.342L617.725 649.322L624.736 656.342ZM613.733 640.791H621.737L617.725 644.808L613.714 640.791H613.733ZM615.461 665.61L608.471 672.63L601.46 665.61L608.471 658.609L615.461 665.61ZM592.205 674.877L599.216 667.877L606.207 674.877L599.216 681.897L592.205 674.877ZM596.932 684.144L589.921 691.164L582.931 684.164L589.941 677.144L596.932 684.144ZM608.471 677.144L615.461 684.164L608.471 691.164L601.46 684.144L608.471 677.144ZM599.216 663.323L592.205 656.303L599.216 649.283L606.207 656.303L599.216 663.323ZM596.932 665.59L589.941 672.61L582.931 665.59L589.941 658.59L596.932 665.59ZM580.667 663.323L573.676 656.303L580.667 649.283L587.677 656.303L580.667 663.323ZM580.667 667.857L587.677 674.857L580.667 681.877L573.676 674.857L580.667 667.857ZM587.677 693.411L580.667 700.411L573.676 693.411L580.667 686.391L587.677 693.411ZM589.941 695.678L596.952 702.698L589.961 709.718L582.95 702.698L589.941 695.678ZM592.225 693.411L599.236 686.391L606.226 693.411L599.236 700.411L592.225 693.411ZM608.49 695.678L615.481 702.698L608.49 709.718L601.48 702.698L608.49 695.678ZM617.745 704.946L624.756 711.966L620.228 716.5H615.302L610.774 711.966L617.785 704.946H617.745ZM610.735 693.411L617.745 686.391L624.756 693.411L617.745 700.411L610.735 693.411ZM610.735 674.857L617.745 667.857L624.756 674.857L617.745 681.877L610.735 674.857ZM615.461 647.035L608.471 654.055L601.46 647.035L607.716 640.771H609.186L615.441 647.035H615.461ZM599.216 644.768L595.204 640.751H603.208L599.216 644.768ZM596.932 647.035L589.941 654.055L582.931 647.035L589.187 640.771H590.656L596.912 647.035H596.932ZM584.678 640.771L580.667 644.788L576.675 640.771H584.678ZM572.147 640.771L578.403 647.035L571.392 654.055L565.295 647.95L565.176 646.28L570.657 640.771H572.127H572.147ZM566.149 640.771L564.858 642.064L564.739 640.771H566.149ZM565.712 652.882L569.148 656.323L566.228 659.246L565.712 652.902V652.882ZM567.619 676.388L567.341 673.067L569.128 674.857L567.599 676.388H567.619ZM567.956 680.604L571.392 677.144L578.403 684.164L571.392 691.164L568.572 688.34L567.956 680.624V680.604ZM568.989 693.57V693.272L569.128 693.431L568.989 693.57ZM570.2 708.505L569.327 697.766L571.392 695.698L578.403 702.718L571.392 709.718L570.2 708.525V708.505ZM570.836 716.52L570.717 714.909L571.392 714.233L573.676 716.52H570.856H570.836ZM573.656 711.986L580.647 704.965L587.657 711.986L583.129 716.52H578.204L573.676 711.986H573.656ZM587.637 716.52L589.921 714.233L592.205 716.52H587.657H587.637ZM596.713 716.52L592.185 711.986L599.196 704.965L606.187 711.986L601.678 716.52H596.753H596.713ZM606.167 716.52L608.451 714.233L610.735 716.52H606.187H606.167ZM627.516 716.52H624.696L626.98 714.233L627.655 714.909L627.536 716.52H627.516ZM628.172 708.505L626.96 709.699L619.95 702.698L626.96 695.678L629.026 697.747L628.152 708.485L628.172 708.505ZM629.403 693.252L629.363 693.57L629.224 693.431L629.403 693.252ZM629.8 688.32L626.96 691.144L619.95 684.144L626.96 677.124L630.416 680.584L629.8 688.3V688.32ZM630.754 676.408L629.224 674.877L631.032 673.087L630.754 676.428V676.408ZM632.66 652.882L632.144 659.266L629.204 656.323L632.64 652.882H632.66Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.463 637.589H561.283L561.839 644.49L562.237 649.422L563.269 662.249L563.865 669.607L564.659 679.411L564.997 683.607L565.116 684.86L565.513 689.792L566.05 696.553L566.387 700.75L566.745 705.025L567.142 709.957L567.44 713.696L567.777 717.892L567.916 719.721H630.495L630.634 717.892L630.972 713.696L631.27 709.917L631.667 704.985L632.025 700.73L632.362 696.534L632.898 689.752L633.296 684.82L633.395 683.567L633.733 679.371L634.527 669.567L635.123 662.229L636.155 649.402L636.553 644.47L637.109 637.569H629.443L629.463 637.589ZM633.574 642.104L632.263 640.791H633.693L633.574 642.104ZM633.236 646.3L633.117 647.97L627.02 654.075L620.009 647.055L626.265 640.791H627.735L633.236 646.3ZM631.468 668.155L627 672.63L619.989 665.61L627 658.609L631.846 663.462L631.468 668.155ZM566.586 663.462L571.432 658.609L578.442 665.61L571.432 672.63L566.983 668.155L566.606 663.462H566.586ZM624.736 656.342L617.725 663.362L610.715 656.342L617.725 649.322L624.736 656.342ZM613.733 640.791H621.737L617.725 644.808L613.714 640.791H613.733ZM615.461 665.61L608.471 672.63L601.46 665.61L608.471 658.609L615.461 665.61ZM592.205 674.877L599.216 667.877L606.207 674.877L599.216 681.897L592.205 674.877ZM596.932 684.144L589.921 691.164L582.931 684.164L589.941 677.144L596.932 684.144ZM608.471 677.144L615.461 684.164L608.471 691.164L601.46 684.144L608.471 677.144ZM599.216 663.323L592.205 656.303L599.216 649.283L606.207 656.303L599.216 663.323ZM596.932 665.59L589.941 672.61L582.931 665.59L589.941 658.59L596.932 665.59ZM580.667 663.323L573.676 656.303L580.667 649.283L587.677 656.303L580.667 663.323ZM580.667 667.857L587.677 674.857L580.667 681.877L573.676 674.857L580.667 667.857ZM587.677 693.411L580.667 700.411L573.676 693.411L580.667 686.391L587.677 693.411ZM589.941 695.678L596.952 702.698L589.961 709.718L582.95 702.698L589.941 695.678ZM592.225 693.411L599.236 686.391L606.226 693.411L599.236 700.411L592.225 693.411ZM608.49 695.678L615.481 702.698L608.49 709.718L601.48 702.698L608.49 695.678ZM617.745 704.946L624.756 711.966L620.228 716.5H615.302L610.774 711.966L617.785 704.946H617.745ZM610.735 693.411L617.745 686.391L624.756 693.411L617.745 700.411L610.735 693.411ZM610.735 674.857L617.745 667.857L624.756 674.857L617.745 681.877L610.735 674.857ZM615.461 647.035L608.471 654.055L601.46 647.035L607.716 640.771H609.186L615.441 647.035H615.461ZM599.216 644.768L595.204 640.751H603.208L599.216 644.768ZM596.932 647.035L589.941 654.055L582.931 647.035L589.187 640.771H590.656L596.912 647.035H596.932ZM584.678 640.771L580.667 644.788L576.675 640.771H584.678ZM572.147 640.771L578.403 647.035L571.392 654.055L565.295 647.95L565.176 646.28L570.657 640.771H572.127H572.147ZM566.149 640.771L564.858 642.064L564.739 640.771H566.149ZM565.712 652.882L569.148 656.323L566.228 659.246L565.712 652.902V652.882ZM567.619 676.388L567.341 673.067L569.128 674.857L567.599 676.388H567.619ZM567.956 680.604L571.392 677.144L578.403 684.164L571.392 691.164L568.572 688.34L567.956 680.624V680.604ZM568.989 693.57V693.272L569.128 693.431L568.989 693.57ZM570.2 708.505L569.327 697.766L571.392 695.698L578.403 702.718L571.392 709.718L570.2 708.525V708.505ZM570.836 716.52L570.717 714.909L571.392 714.233L573.676 716.52H570.856H570.836ZM573.656 711.986L580.647 704.965L587.657 711.986L583.129 716.52H578.204L573.676 711.986H573.656ZM587.637 716.52L589.921 714.233L592.205 716.52H587.657H587.637ZM596.713 716.52L592.185 711.986L599.196 704.965L606.187 711.986L601.678 716.52H596.753H596.713ZM606.167 716.52L608.451 714.233L610.735 716.52H606.187H606.167ZM627.516 716.52H624.696L626.98 714.233L627.655 714.909L627.536 716.52H627.516ZM628.172 708.505L626.96 709.699L619.95 702.698L626.96 695.678L629.026 697.747L628.152 708.485L628.172 708.505ZM629.403 693.252L629.363 693.57L629.224 693.431L629.403 693.252ZM629.8 688.32L626.96 691.144L619.95 684.144L626.96 677.124L630.416 680.584L629.8 688.3V688.32ZM630.754 676.408L629.224 674.877L631.032 673.087L630.754 676.428V676.408ZM632.66 652.882L632.144 659.266L629.204 656.323L632.64 652.882H632.66Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M560.151 643.654H638.241C640.039 643.654 641.498 642.194 641.498 640.393V637.987C641.498 636.185 640.039 634.725 638.241 634.725H560.151C558.352 634.725 556.894 636.185 556.894 637.987V640.393C556.894 642.194 558.352 643.654 560.151 643.654Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.143 714.949H566.268C564.469 714.949 563.011 716.409 563.011 718.211V720.617C563.011 722.418 564.469 723.878 566.268 723.878H632.143C633.942 723.878 635.4 722.418 635.4 720.617V718.211C635.4 716.409 633.942 714.949 632.143 714.949Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.011 186.279H464.506V456.6H861.011V186.279Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M861.011 186.279H464.506V456.6H861.011V186.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M719.806 186.279C719.806 186.279 605.71 293.23 464.506 295.776V186.279H719.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M860.991 327.395C860.991 327.395 782.643 319.222 705.129 364.305C627.616 409.368 550.182 451.866 464.486 431.94V456.599H860.991V327.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.54 247.392H567.937V279.906H757.54V247.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.54 293.509H567.937V326.024H757.54V293.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.917 266.821V267.676H578.323V258.35H584.718V259.205H579.316V262.526H584.122V263.361H579.316V266.821H584.917Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.228 263.639H589.703V264.474H586.228V263.639Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.366 263.599V267.656H602.413V263.679C602.413 262.207 601.658 261.432 600.407 261.432C598.977 261.432 598.064 262.366 598.064 263.957V267.636H597.111V263.659C597.111 262.187 596.356 261.412 595.085 261.412C593.655 261.412 592.741 262.346 592.741 263.937V267.616H591.788V260.616H592.702V261.889C593.198 261.054 594.092 260.557 595.264 260.557C596.435 260.557 597.329 261.054 597.746 262.028C598.243 261.113 599.255 260.557 600.507 260.557C602.215 260.557 603.327 261.551 603.327 263.56L603.366 263.599Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.212 263.321V267.656H610.298V266.563C609.881 267.279 609.047 267.716 607.895 267.716C606.306 267.716 605.333 266.881 605.333 265.688C605.333 264.614 606.028 263.699 608.034 263.699H610.258V263.281C610.258 262.088 609.583 261.432 608.272 261.432C607.359 261.432 606.525 261.75 605.949 262.247L605.532 261.551C606.227 260.955 607.279 260.597 608.372 260.597C610.179 260.597 611.212 261.511 611.212 263.321ZM610.258 265.548V264.395H608.074C606.723 264.395 606.286 264.932 606.286 265.648C606.286 266.463 606.942 266.96 608.054 266.96C609.166 266.96 609.901 266.463 610.278 265.529L610.258 265.548Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.555 258.448C613.555 258.09 613.853 257.792 614.25 257.792C614.647 257.792 614.945 258.09 614.945 258.448C614.945 258.826 614.647 259.144 614.25 259.144C613.853 259.144 613.555 258.846 613.555 258.468V258.448ZM613.773 260.656H614.726V267.656H613.773V260.656Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.348 257.772H618.301V267.656H617.348V257.772Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.612 307.688C585.612 309.677 584.182 310.87 581.799 310.87H579.297V313.813H578.304V304.486H581.779C584.143 304.486 585.592 305.68 585.592 307.688H585.612ZM584.619 307.688C584.619 306.197 583.626 305.341 581.779 305.341H579.297V309.995H581.779C583.646 309.995 584.619 309.14 584.619 307.668V307.688Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.742 309.477V313.813H591.828V312.719C591.411 313.435 590.577 313.872 589.425 313.872C587.836 313.872 586.863 313.037 586.863 311.844C586.863 310.77 587.558 309.855 589.564 309.855H591.789V309.438C591.789 308.244 591.113 307.588 589.803 307.588C588.909 307.588 588.055 307.906 587.479 308.404L587.062 307.707C587.777 307.111 588.81 306.753 589.902 306.753C591.709 306.753 592.742 307.668 592.742 309.477ZM591.789 311.705V310.551H589.584C588.234 310.551 587.797 311.088 587.797 311.804C587.797 312.62 588.452 313.117 589.564 313.117C590.676 313.117 591.411 312.62 591.789 311.685V311.705Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.331 313.018L594.748 312.262C595.304 312.699 596.257 313.037 597.23 313.037C598.561 313.037 599.097 312.58 599.097 311.884C599.097 310.054 594.569 311.506 594.569 308.722C594.569 307.569 595.562 306.733 597.33 306.733C598.243 306.733 599.216 306.992 599.812 307.39L599.395 308.145C598.78 307.728 598.045 307.549 597.33 307.549C596.059 307.549 595.503 308.046 595.503 308.702C595.503 310.591 600.031 309.16 600.031 311.864C600.031 313.077 598.958 313.853 597.151 313.853C595.999 313.853 594.887 313.475 594.311 312.978L594.331 313.018Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.845 313.018L601.262 312.262C601.818 312.699 602.771 313.037 603.745 313.037C605.075 313.037 605.611 312.58 605.611 311.884C605.611 310.054 601.083 311.506 601.083 308.722C601.083 307.569 602.076 306.733 603.844 306.733C604.757 306.733 605.731 306.992 606.326 307.39L605.909 308.145C605.294 307.728 604.559 307.549 603.844 307.549C602.573 307.549 602.017 308.046 602.017 308.702C602.017 310.591 606.545 309.16 606.545 311.864C606.545 313.077 605.472 313.853 603.665 313.853C602.513 313.853 601.401 313.475 600.825 312.978L600.845 313.018Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.441 306.812L615.8 313.813H614.906L612.701 308.065L610.497 313.813H609.603L606.962 306.812H607.875L610.06 312.759L612.304 306.812H613.119L615.343 312.759L617.567 306.812H618.441Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.957 310.313C618.957 308.244 620.466 306.753 622.532 306.753C624.597 306.753 626.087 308.225 626.087 310.313C626.087 312.401 624.577 313.892 622.532 313.892C620.486 313.892 618.957 312.401 618.957 310.313ZM625.114 310.313C625.114 308.682 624.001 307.588 622.512 307.588C621.022 307.588 619.91 308.682 619.91 310.313C619.91 311.943 621.022 313.037 622.512 313.037C624.001 313.037 625.114 311.943 625.114 310.313Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.509 306.753V307.668C631.509 307.668 631.35 307.668 631.29 307.668C629.821 307.668 628.927 308.602 628.927 310.253V313.833H627.974V306.832H628.887V308.205C629.324 307.27 630.218 306.773 631.509 306.773V306.753Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.532 303.929V313.813H638.618V312.421C638.042 313.375 637.069 313.872 635.917 313.872C633.931 313.872 632.442 312.421 632.442 310.293C632.442 308.165 633.931 306.733 635.917 306.733C637.03 306.733 638.003 307.21 638.579 308.125V303.909H639.532V303.929ZM638.598 310.313C638.598 308.682 637.486 307.588 635.997 307.588C634.507 307.588 633.395 308.682 633.395 310.313C633.395 311.943 634.507 313.037 635.997 313.037C637.486 313.037 638.598 311.943 638.598 310.313Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M759.526 359.175H569.922V391.69H759.526V359.175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.596 345.711L592.324 343.921C592.185 343.921 592.046 343.941 591.888 343.941H590.398V345.711H589.802V340.143H591.888C593.298 340.143 594.152 340.859 594.152 342.052C594.152 342.927 593.695 343.543 592.881 343.802L594.231 345.711H593.596ZM593.556 342.052C593.556 341.157 592.96 340.66 591.848 340.66H590.378V343.444H591.848C592.96 343.444 593.556 342.927 593.556 342.052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.057 343.802H595.561C595.621 344.677 596.296 345.254 597.21 345.254C597.726 345.254 598.163 345.075 598.481 344.697L598.799 345.055C598.421 345.493 597.845 345.731 597.19 345.731C595.879 345.731 595.005 344.836 595.005 343.603C595.005 342.37 595.879 341.476 597.051 341.476C598.223 341.476 599.077 342.351 599.077 343.603C599.077 343.643 599.077 343.723 599.077 343.782L599.057 343.802ZM595.561 343.385H598.521C598.441 342.569 597.845 341.993 597.031 341.993C596.217 341.993 595.621 342.569 595.561 343.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.12 343.285V345.711H606.564V343.345C606.564 342.47 606.127 342.012 605.373 342.012C604.519 342.012 603.982 342.569 603.982 343.524V345.711H603.426V343.345C603.426 342.47 602.989 342.012 602.215 342.012C601.361 342.012 600.825 342.569 600.825 343.524V345.711H600.269V341.535H600.805V342.291C601.103 341.793 601.639 341.495 602.334 341.495C603.029 341.495 603.565 341.793 603.824 342.37C604.121 341.833 604.717 341.495 605.472 341.495C606.485 341.495 607.16 342.092 607.16 343.285H607.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.303 343.802H608.808C608.868 344.677 609.543 345.254 610.456 345.254C610.973 345.254 611.41 345.075 611.727 344.697L612.045 345.055C611.668 345.493 611.092 345.731 610.437 345.731C609.126 345.731 608.252 344.836 608.252 343.603C608.252 342.37 609.126 341.476 610.298 341.476C611.469 341.476 612.323 342.351 612.323 343.603C612.323 343.643 612.323 343.723 612.323 343.782L612.303 343.802ZM608.808 343.385H611.767C611.688 342.569 611.092 341.993 610.278 341.993C609.463 341.993 608.868 342.569 608.808 343.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.367 343.285V345.711H619.811V343.345C619.811 342.47 619.374 342.012 618.619 342.012C617.765 342.012 617.229 342.569 617.229 343.524V345.711H616.673V343.345C616.673 342.47 616.236 342.012 615.461 342.012C614.607 342.012 614.071 342.569 614.071 343.524V345.711H613.515V341.535H614.051V342.291C614.349 341.793 614.885 341.495 615.581 341.495C616.276 341.495 616.812 341.793 617.07 342.37C617.368 341.833 617.964 341.495 618.718 341.495C619.731 341.495 620.407 342.092 620.407 343.285H620.367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.126 343.623C626.126 344.896 625.232 345.751 624.041 345.751C623.346 345.751 622.77 345.453 622.432 344.876V345.711H621.896V339.805H622.452V342.31C622.81 341.773 623.366 341.475 624.041 341.475C625.232 341.475 626.126 342.33 626.126 343.603V343.623ZM625.57 343.623C625.57 342.648 624.895 341.992 624.021 341.992C623.147 341.992 622.472 342.648 622.472 343.623C622.472 344.597 623.147 345.254 624.021 345.254C624.895 345.254 625.57 344.597 625.57 343.623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.912 343.802H627.417C627.476 344.677 628.152 345.254 629.065 345.254C629.582 345.254 630.019 345.075 630.336 344.697L630.654 345.055C630.277 345.493 629.701 345.731 629.045 345.731C627.735 345.731 626.861 344.836 626.861 343.603C626.861 342.37 627.735 341.476 628.906 341.476C630.078 341.476 630.932 342.351 630.932 343.603C630.932 343.643 630.932 343.723 630.932 343.782L630.912 343.802ZM627.417 343.385H630.376C630.297 342.569 629.701 341.993 628.887 341.993C628.072 341.993 627.476 342.569 627.417 343.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.189 341.495V342.052C634.189 342.052 634.09 342.052 634.05 342.052C633.176 342.052 632.64 342.609 632.64 343.603V345.731H632.084V341.555H632.62V342.37C632.878 341.813 633.415 341.515 634.189 341.515V341.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.238 343.285V345.711H643.682V343.345C643.682 342.47 643.245 342.012 642.491 342.012C641.637 342.012 641.101 342.569 641.101 343.524V345.711H640.544V343.345C640.544 342.47 640.108 342.012 639.333 342.012C638.479 342.012 637.943 342.569 637.943 343.524V345.711H637.387V341.535H637.923V342.291C638.221 341.793 638.757 341.495 639.452 341.495C640.147 341.495 640.683 341.793 640.942 342.37C641.24 341.833 641.835 341.495 642.59 341.495C643.603 341.495 644.278 342.092 644.278 343.285H644.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.422 343.802H645.927C645.986 344.677 646.662 345.254 647.575 345.254C648.091 345.254 648.528 345.075 648.846 344.697L649.164 345.055C648.787 345.493 648.211 345.731 647.555 345.731C646.244 345.731 645.371 344.836 645.371 343.603C645.371 342.37 646.244 341.476 647.416 341.476C648.588 341.476 649.442 342.351 649.442 343.603C649.442 343.643 649.442 343.723 649.442 343.782L649.422 343.802ZM645.927 343.385H648.886C648.806 342.569 648.211 341.993 647.396 341.993C646.582 341.993 645.986 342.569 645.927 343.385Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M757.54 357.186H567.937V389.7H757.54V357.186Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.51 410.343V412.53H631.39V413.047H628.51V415.414H627.914V409.846H631.727V410.363H628.51V410.343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.263 413.307C632.263 412.074 633.177 411.179 634.388 411.179C635.6 411.179 636.513 412.054 636.513 413.307C636.513 414.559 635.62 415.434 634.388 415.434C633.157 415.434 632.263 414.54 632.263 413.307ZM635.937 413.307C635.937 412.332 635.282 411.676 634.388 411.676C633.495 411.676 632.839 412.332 632.839 413.307C632.839 414.281 633.514 414.937 634.388 414.937C635.262 414.937 635.937 414.281 635.937 413.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.77 411.198V411.755C639.77 411.755 639.671 411.755 639.631 411.755C638.757 411.755 638.221 412.312 638.221 413.306V415.434H637.665V411.258H638.201V412.073C638.459 411.516 638.996 411.218 639.77 411.218V411.198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.616 411.218V414.897C644.616 416.329 643.901 416.985 642.531 416.985C641.776 416.985 641.022 416.746 640.585 416.349L640.863 415.911C641.26 416.269 641.856 416.488 642.511 416.488C643.564 416.488 644.06 416.01 644.06 414.976V414.439C643.703 414.976 643.107 415.255 642.432 415.255C641.24 415.255 640.327 414.42 640.327 413.226C640.327 412.033 641.24 411.218 642.432 411.218C643.127 411.218 643.743 411.496 644.08 412.053V411.258H644.616V411.218ZM644.06 413.206C644.06 412.292 643.385 411.675 642.472 411.675C641.558 411.675 640.883 412.292 640.883 413.206C640.883 414.121 641.538 414.738 642.472 414.738C643.405 414.738 644.06 414.101 644.06 413.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.788 413.307C645.788 412.074 646.702 411.179 647.913 411.179C649.125 411.179 650.038 412.054 650.038 413.307C650.038 414.559 649.144 415.434 647.913 415.434C646.682 415.434 645.788 414.54 645.788 413.307ZM649.462 413.307C649.462 412.332 648.807 411.676 647.913 411.676C647.019 411.676 646.364 412.332 646.364 413.307C646.364 414.281 647.039 414.937 647.913 414.937C648.787 414.937 649.462 414.281 649.462 413.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.374 415.156C653.156 415.355 652.818 415.454 652.501 415.454C651.706 415.454 651.269 415.017 651.269 414.241V411.715H650.515V411.238H651.269V410.323H651.825V411.238H653.096V411.715H651.825V414.201C651.825 414.698 652.084 414.957 652.54 414.957C652.779 414.957 652.997 414.877 653.156 414.738L653.355 415.136L653.374 415.156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.961 411.755C660.961 412.948 660.107 413.664 658.697 413.664H657.208V415.414H656.612V409.846H658.697C660.107 409.846 660.961 410.562 660.961 411.755ZM660.365 411.755C660.365 410.86 659.77 410.363 658.657 410.363H657.188V413.147H658.657C659.77 413.147 660.365 412.63 660.365 411.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.231 412.809V415.395H664.695V414.738C664.437 415.176 663.94 415.434 663.265 415.434C662.312 415.434 661.736 414.937 661.736 414.221C661.736 413.585 662.153 413.028 663.344 413.028H664.675V412.77C664.675 412.054 664.278 411.656 663.483 411.656C662.947 411.656 662.431 411.855 662.093 412.153L661.835 411.736C662.252 411.378 662.868 411.179 663.543 411.179C664.615 411.179 665.231 411.716 665.231 412.809ZM664.675 414.142V413.466H663.364C662.55 413.466 662.292 413.784 662.292 414.221C662.292 414.699 662.689 415.017 663.344 415.017C664 415.017 664.457 414.719 664.675 414.162V414.142Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.184 414.937L666.443 414.499C666.78 414.758 667.336 414.976 667.932 414.976C668.727 414.976 669.044 414.698 669.044 414.3C669.044 413.206 666.343 414.062 666.343 412.411C666.343 411.735 666.939 411.218 667.992 411.218C668.528 411.218 669.124 411.377 669.461 411.616L669.223 412.073C668.866 411.814 668.429 411.715 667.992 411.715C667.237 411.715 666.899 412.013 666.899 412.411C666.899 413.545 669.6 412.689 669.6 414.3C669.6 415.016 668.965 415.493 667.873 415.493C667.177 415.493 666.522 415.275 666.165 414.976L666.184 414.937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.057 414.937L670.315 414.499C670.653 414.758 671.209 414.976 671.805 414.976C672.599 414.976 672.917 414.698 672.917 414.3C672.917 413.206 670.216 414.062 670.216 412.411C670.216 411.735 670.812 411.218 671.864 411.218C672.4 411.218 672.996 411.377 673.334 411.616L673.096 412.073C672.738 411.814 672.301 411.715 671.864 411.715C671.11 411.715 670.772 412.013 670.772 412.411C670.772 413.545 673.473 412.689 673.473 414.3C673.473 415.016 672.837 415.493 671.745 415.493C671.05 415.493 670.395 415.275 670.037 414.976L670.057 414.937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.583 411.218L678.994 415.394H678.458L677.147 411.973L675.836 415.394H675.3L673.731 411.218H674.267L675.578 414.778L676.928 411.218H677.405L678.736 414.778L680.066 411.218H680.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.9 413.307C680.9 412.074 681.814 411.179 683.025 411.179C684.237 411.179 685.15 412.054 685.15 413.307C685.15 414.559 684.257 415.434 683.025 415.434C681.794 415.434 680.9 414.54 680.9 413.307ZM684.575 413.307C684.575 412.332 683.919 411.676 683.025 411.676C682.132 411.676 681.476 412.332 681.476 413.307C681.476 414.281 682.152 414.937 683.025 414.937C683.899 414.937 684.575 414.281 684.575 413.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.388 411.198V411.755C688.388 411.755 688.289 411.755 688.249 411.755C687.375 411.755 686.839 412.312 686.839 413.306V415.434H686.283V411.258H686.819V412.073C687.077 411.516 687.613 411.218 688.388 411.218V411.198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.194 409.508V415.414H692.658V414.579C692.32 415.136 691.744 415.454 691.049 415.454C689.858 415.454 688.964 414.579 688.964 413.326C688.964 412.073 689.858 411.198 691.049 411.198C691.724 411.198 692.28 411.477 692.638 412.033V409.528H693.194V409.508ZM692.638 413.306C692.638 412.332 691.963 411.675 691.089 411.675C690.215 411.675 689.54 412.332 689.54 413.306C689.54 414.281 690.215 414.937 691.089 414.937C691.963 414.937 692.638 414.281 692.638 413.306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.285 411.258C697.285 410.681 696.808 410.284 696.014 410.284C695.339 410.284 694.842 410.502 694.505 410.92L694.087 410.602C694.524 410.085 695.18 409.767 696.073 409.767C697.186 409.767 697.901 410.304 697.901 411.159C697.901 412.511 696.451 412.59 696.451 413.724H695.855C695.855 412.412 697.305 412.292 697.305 411.258H697.285ZM695.716 415.037C695.716 414.798 695.895 414.639 696.133 414.639C696.371 414.639 696.55 414.818 696.55 415.037C696.55 415.255 696.371 415.454 696.133 415.454C695.895 415.454 695.716 415.255 695.716 415.037Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M579.018 336.981H569.386V346.627H579.018V336.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.816 367.348H643.405V377.092H649.422V378.484H641.816V367.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.137 374.268C650.137 371.762 652.004 369.973 654.526 369.973C657.049 369.973 658.895 371.762 658.895 374.268C658.895 376.774 657.049 378.584 654.526 378.584C652.004 378.584 650.137 376.794 650.137 374.268ZM657.346 374.268C657.346 372.478 656.135 371.305 654.526 371.305C652.918 371.305 651.686 372.459 651.686 374.268C651.686 376.078 652.918 377.251 654.526 377.251C656.135 377.251 657.346 376.078 657.346 374.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.064 370.053V377.331C669.064 380.314 667.554 381.647 664.695 381.647C663.145 381.647 661.596 381.209 660.683 380.394L661.418 379.22C662.192 379.877 663.424 380.314 664.655 380.314C666.641 380.314 667.535 379.399 667.535 377.49V376.814C666.8 377.689 665.707 378.127 664.496 378.127C662.073 378.127 660.226 376.476 660.226 374.03C660.226 371.584 662.073 369.953 664.496 369.953C665.747 369.953 666.899 370.411 667.614 371.345V370.033H669.064V370.053ZM667.574 374.05C667.574 372.419 666.363 371.305 664.675 371.305C662.987 371.305 661.775 372.399 661.775 374.05C661.775 375.7 662.987 376.794 664.675 376.794C666.363 376.794 667.574 375.661 667.574 374.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.705 367.447C671.705 366.891 672.142 366.453 672.738 366.453C673.334 366.453 673.771 366.891 673.771 367.428C673.771 368.004 673.334 368.442 672.738 368.442C672.142 368.442 671.705 368.004 671.705 367.447ZM671.983 370.053H673.512V378.485H671.983V370.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.396 373.632V378.484H682.867V373.811C682.867 372.16 682.033 371.345 680.603 371.345C678.974 371.345 677.941 372.319 677.941 374.149V378.484H676.412V370.052H677.882V371.325C678.497 370.47 679.59 369.973 680.92 369.973C682.966 369.973 684.416 371.146 684.416 373.632H684.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.319 344.458L571.194 342.131L571.929 341.475L573.339 343.006L576.516 339.705L577.231 340.401L573.319 344.458Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M739.547 315.782C736.25 315.782 733.172 313.953 730.848 310.651L730.649 310.373L730.848 310.095C733.152 306.793 736.25 304.964 739.547 304.964C742.843 304.964 745.922 306.793 748.245 310.095L748.444 310.373L748.245 310.651C745.942 313.953 742.843 315.782 739.547 315.782ZM731.881 310.373C733.966 313.217 736.687 314.788 739.547 314.788C742.407 314.788 745.127 313.217 747.213 310.373C745.127 307.529 742.407 305.958 739.547 305.958C736.687 305.958 733.966 307.529 731.881 310.373Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.547 314.052C737.521 314.052 735.873 312.402 735.873 310.373C735.873 308.345 737.521 306.694 739.547 306.694C741.572 306.694 743.221 308.345 743.221 310.373C743.221 312.402 741.572 314.052 739.547 314.052ZM739.547 307.669C738.057 307.669 736.866 308.882 736.866 310.353C736.866 311.825 738.077 313.038 739.547 313.038C741.016 313.038 742.228 311.825 742.228 310.353C742.228 308.882 741.016 307.669 739.547 307.669Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.053 304.169L733.341 315.896L734.043 316.6L745.755 304.872L745.053 304.169Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.591 232.615L639.989 231.82C640.684 232.496 641.915 233.013 643.206 233.013C645.033 233.013 645.827 232.257 645.827 231.283C645.827 228.618 639.83 230.249 639.83 226.649C639.83 225.217 640.942 223.984 643.424 223.984C644.517 223.984 645.668 224.303 646.443 224.84L646.105 225.655C645.271 225.118 644.298 224.84 643.444 224.84C641.657 224.84 640.862 225.635 640.862 226.609C640.862 229.274 646.86 227.663 646.86 231.223C646.86 232.655 645.728 233.888 643.226 233.888C641.756 233.888 640.326 233.371 639.611 232.615H639.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.647 224.164C648.647 223.786 648.965 223.468 649.362 223.468C649.76 223.468 650.077 223.766 650.077 224.144C650.077 224.542 649.78 224.86 649.362 224.86C648.945 224.86 648.647 224.542 648.647 224.144V224.164ZM648.866 226.471H649.859V233.789H648.866V226.471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.392 226.47V232.913C659.392 235.439 658.16 236.573 655.737 236.573C654.407 236.573 653.096 236.175 652.321 235.439L652.818 234.683C653.513 235.3 654.566 235.678 655.698 235.678C657.545 235.678 658.399 234.823 658.399 233.013V232.078C657.783 233.013 656.75 233.49 655.539 233.49C653.453 233.49 651.865 232.019 651.865 229.93C651.865 227.842 653.453 226.391 655.539 226.391C656.77 226.391 657.823 226.888 658.438 227.862V226.45H659.392V226.47ZM658.438 229.95C658.438 228.359 657.267 227.286 655.658 227.286C654.049 227.286 652.897 228.379 652.897 229.95C652.897 231.521 654.049 232.635 655.658 232.635C657.267 232.635 658.438 231.541 658.438 229.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.885 229.553V233.809H667.892V229.653C667.892 228.102 667.077 227.306 665.687 227.306C664.118 227.306 663.125 228.28 663.125 229.951V233.789H662.132V226.471H663.086V227.823C663.622 226.928 664.595 226.411 665.866 226.411C667.653 226.411 668.865 227.445 668.865 229.553H668.885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.982 224.164C674.982 223.786 675.3 223.468 675.697 223.468C676.094 223.468 676.412 223.766 676.412 224.144C676.412 224.542 676.114 224.86 675.697 224.86C675.28 224.86 674.982 224.542 674.982 224.144V224.164ZM675.2 226.471H676.193V233.789H675.2V226.471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.666 229.553V233.809H684.673V229.653C684.673 228.102 683.859 227.306 682.469 227.306C680.9 227.306 679.907 228.28 679.907 229.951V233.789H678.914V226.471H679.867V227.823C680.404 226.928 681.377 226.411 682.648 226.411C684.435 226.411 685.647 227.445 685.647 229.553H685.666Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.022 185.563H302.964C293.253 185.563 285.388 193.439 285.388 203.163V252.88C285.388 262.605 293.253 270.48 302.964 270.48H319.627L305.665 298.122L331.444 270.48H360.022C369.734 270.48 377.598 262.605 377.598 252.88V203.163C377.598 193.439 369.734 185.563 360.022 185.563Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M360.022 185.563H302.964C293.253 185.563 285.388 193.439 285.388 203.163V252.88C285.388 262.605 293.253 270.48 302.964 270.48H319.627L305.665 298.122L331.444 270.48H360.022C369.734 270.48 377.598 262.605 377.598 252.88V203.163C377.598 193.439 369.734 185.563 360.022 185.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.513 247.847C362.573 236.773 362.573 218.817 351.513 207.742C340.453 196.668 322.522 196.668 311.462 207.742C300.402 218.817 300.402 236.773 311.462 247.847C322.522 258.922 340.453 258.922 351.513 247.847Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.524 240.47C327.769 240.47 327.035 240.132 326.538 239.556L315.436 226.45C314.503 225.357 314.642 223.706 315.734 222.771C316.827 221.837 318.475 221.976 319.408 223.07L328.544 233.828L343.618 216.05C344.551 214.956 346.2 214.817 347.292 215.751C348.384 216.686 348.523 218.336 347.59 219.43L330.53 239.556C330.033 240.132 329.319 240.47 328.544 240.47H328.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.11 720.238H522.695C523.946 720.238 524.959 719.224 524.959 717.971V710.593C524.959 709.34 523.946 708.326 522.695 708.326H413.068V472.032H520.828C523.112 472.032 524.979 470.182 524.979 467.875V460.1H407.13C403.833 460.1 401.172 462.764 401.172 466.066V714.292C401.172 717.593 403.833 720.258 407.13 720.258L407.11 720.238Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.152 466.046V714.253C401.152 717.554 403.813 720.219 407.11 720.219H522.695C523.946 720.219 524.959 719.204 524.959 717.951V710.574C524.959 709.321 523.946 708.287 522.695 708.287H413.068V472.012H520.828C523.112 472.012 524.959 470.143 524.959 467.856V460.08H407.11C403.813 460.08 401.152 462.745 401.152 466.046Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M401.152 466.046V529.346C405.124 530.36 409.096 531.334 413.068 532.269V472.012H520.828C523.112 472.012 524.959 470.143 524.959 467.856V460.08H407.11C403.813 460.08 401.152 462.745 401.152 466.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.145 686.927L239.551 682.791V620.466H256.214V682.771L303.778 686.927C307.969 687.345 311.166 690.865 311.166 695.081V701.405H184.777V695.081C184.777 690.865 187.975 687.345 192.165 686.927H192.145Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.145 686.927L239.551 682.791V620.466H256.214V682.771L303.778 686.927C307.969 687.345 311.166 690.865 311.166 695.081V701.405H184.777V695.081C184.777 690.865 187.975 687.345 192.165 686.927H192.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.795 709.241C295.795 715.267 300.68 720.159 306.698 720.159C312.716 720.159 317.601 715.267 317.601 709.241C317.601 703.215 312.716 698.323 306.698 698.323C300.68 698.323 295.795 703.215 295.795 709.241Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.089 709.241C200.089 715.267 195.204 720.159 189.186 720.159C183.169 720.159 178.283 715.267 178.283 709.241C178.283 703.215 183.169 698.323 189.186 698.323C195.204 698.323 200.089 703.215 200.089 709.241Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.686 633.174H244.04C239.968 633.174 236.672 629.873 236.672 625.796V572.161H259.074V625.796C259.074 629.873 255.777 633.174 251.706 633.174H251.686Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M251.686 633.174H244.04C239.968 633.174 236.672 629.873 236.672 625.796V572.161H259.074V625.796C259.074 629.873 255.777 633.174 251.706 633.174H251.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.719 448.863C198.719 448.863 203.843 551.936 226.026 569.675H202.314C202.314 569.675 181.163 534.555 179.594 448.863H198.719Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M198.719 448.863C198.719 448.863 203.843 551.936 226.026 569.675H202.314C202.314 569.675 181.163 534.555 179.594 448.863H198.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.792 561.124H301.892C306.817 561.124 310.809 565.121 310.809 570.053V578.207H187.855V570.053C187.855 565.121 191.847 561.124 196.773 561.124H196.792Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.901 569.676H186.783C184.798 569.676 183.188 571.287 183.188 573.275V574.608C183.188 576.596 184.798 578.207 186.783 578.207H311.901C313.886 578.207 315.496 576.596 315.496 574.608V573.275C315.496 571.287 313.886 569.676 311.901 569.676Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M311.901 569.676H186.783C184.798 569.676 183.188 571.287 183.188 573.275V574.608C183.188 576.596 184.798 578.207 186.783 578.207H311.901C313.886 578.207 315.496 576.596 315.496 574.608V573.275C315.496 571.287 313.886 569.676 311.901 569.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.423 471.415H213.396C224.517 471.415 232.561 461.412 231.349 449.062L229.721 432.576C228.509 420.227 218.5 410.224 207.378 410.224H169.406C158.284 410.224 150.241 420.227 151.452 432.576L153.081 449.062C154.292 461.412 164.302 471.415 175.423 471.415Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.8 382.502L302.627 388.11C303.262 390.019 303.937 391.928 304.633 393.837C306.003 397.636 307.473 401.375 309.002 404.974C310.551 408.574 312.239 412.054 314.026 415.176C315.814 418.258 317.839 421.082 319.448 422.534C320.461 423.648 323.48 425.02 326.915 425.935C330.391 426.81 334.264 427.546 338.236 428.003C346.18 428.997 354.66 429.395 362.902 429.733L364.371 440.85C355.593 443.216 346.895 444.588 337.699 445.086C333.112 445.265 328.405 445.285 323.44 444.628C320.938 444.29 318.376 443.813 315.655 442.998C314.304 442.6 312.894 442.063 311.445 441.387C310.054 440.77 308.366 439.776 307.115 438.861C301.892 435.083 298.694 430.926 295.835 426.81C292.995 422.693 290.711 418.537 288.665 414.341C286.6 410.165 284.832 405.929 283.243 401.673C282.469 399.545 281.714 397.397 280.999 395.23C280.264 393.042 279.649 390.974 279.013 388.528L300.819 382.442L300.8 382.502Z",
    fill: "#B65B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.049 372.021C297.304 374.169 303.004 383.178 318.714 419.312C318.714 419.312 321.275 423.747 334.026 426.491L332.854 446.796C332.854 446.796 314.622 446 310.392 443.057C306.162 440.114 280.801 398.371 280.801 398.371L291.029 372.021H291.049Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.045 426.491L332.873 446.776C332.873 446.776 318.256 446.139 312.159 443.892C311.444 443.634 310.849 443.355 310.412 443.057C307.969 441.347 298.436 426.65 290.85 414.559C285.309 405.769 280.82 398.352 280.82 398.352L291.048 372.021C297.304 374.169 303.004 383.178 318.733 419.292C318.733 419.292 321.275 423.727 334.045 426.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.159 443.892C311.444 443.634 310.849 443.355 310.412 443.057C307.969 441.347 298.436 426.651 290.85 414.559C294.107 403.224 297.84 394.354 297.84 394.354C297.84 394.354 312.437 423.528 312.159 443.892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.552 430.747L372.792 425.597L371.044 444.688C371.044 444.688 357.976 446.358 356.368 439.478L358.552 430.747Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.589 429.475L382.404 445.185L371.044 444.708L372.792 425.597L384.589 429.475Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.145 425.597L341.413 427.784L338.752 447.532L331.483 448.785L334.145 425.597Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.356 497.447C301.356 497.447 397.458 535.411 419.801 551.281C442.143 567.15 498.506 674.141 498.506 674.141L475.21 692.119C475.21 692.119 408.004 594.395 399.802 587.773C391.6 581.151 284.554 548.278 284.554 548.278L301.356 497.467V497.447Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M498.526 674.141L475.23 692.119C475.23 692.119 459.541 669.309 442.402 644.987C424.071 618.955 404.072 591.193 399.822 587.773C393.824 582.921 334.979 564.028 303.779 554.244C292.3 550.624 284.574 548.258 284.574 548.258L301.376 497.447C301.376 497.447 397.458 535.411 419.821 551.281C442.163 567.15 498.526 674.141 498.526 674.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.756 712.423L513.977 701.127L495.626 672.709L484.425 684.005L502.756 712.423Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M484.425 684.004L495.626 672.729L506.112 688.956L494.514 699.675L484.425 684.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.923 699.894C515.923 699.894 516.003 699.954 516.043 699.934C516.082 699.934 516.122 699.874 516.142 699.835C517.472 699.357 518.743 698.721 519.935 697.965C520.888 697.468 521.603 696.653 521.981 695.658C522.12 694.903 521.822 694.127 521.206 693.69C520.869 693.352 520.392 693.192 519.915 693.292C518.823 693.55 517.751 695.102 516.936 696.593C516.976 695.022 516.718 693.411 516.023 692.715C515.546 692.258 514.851 692.158 514.295 692.516C513.778 692.775 513.441 693.212 513.322 693.769C512.865 695.917 515.764 699.377 515.903 699.576L516.082 699.357L515.903 699.576C515.903 699.576 515.745 699.795 515.765 699.815C515.824 699.854 515.864 699.874 515.923 699.874V699.894ZM516.023 698.423C515.963 698.542 515.923 698.661 515.864 698.761C514.99 697.528 513.699 695.36 513.977 694.087C514.017 693.789 514.196 693.531 514.454 693.371L514.613 693.272C515.089 693.033 515.347 693.173 515.486 693.332C516.221 694.127 516.38 696.673 516.023 698.423ZM516.678 698.92C517.552 696.911 519.022 694.326 520.094 694.087C520.332 694.028 520.571 694.107 520.73 694.286C521.107 694.584 521.305 695.062 521.246 695.539C521.027 696.573 519.339 697.806 516.678 698.92Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.759 698.88L498.943 708.823C498.407 709.141 498.248 709.838 498.566 710.374L505.715 722.605C506.569 723.878 508.297 724.236 509.588 723.4C514.692 719.841 516.956 717.892 523.45 713.457C527.442 710.752 535.585 705.801 540.47 701.266C545.356 696.712 540.728 692.019 538.266 693.511C532.407 697.03 522.219 698.542 516.539 698.104C515.546 698.045 514.573 698.303 513.759 698.86V698.88Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.283 699.934L505.377 680.525L498.665 666.843L467.147 688.738L476.283 699.934Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M476.283 699.934L505.377 680.525L498.665 666.843L467.147 688.738L476.283 699.934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M442.401 644.987C424.07 618.955 404.071 591.193 399.821 587.773C393.824 582.92 334.978 564.028 303.778 554.244L300.144 516.359L311.544 514.331L312.835 517.235C312.835 517.235 384.053 533.402 404.171 543.505C417.159 550.028 434.576 613.824 442.401 644.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.131 703.653C438.131 703.653 438.191 703.733 438.231 703.733C438.27 703.733 438.31 703.713 438.35 703.673C439.76 703.673 441.17 703.494 442.54 703.176C443.593 703.037 444.566 702.5 445.241 701.665C445.619 701.008 445.599 700.173 445.162 699.537C444.963 699.099 444.546 698.781 444.069 698.721C442.957 698.602 441.428 699.716 440.157 700.849C440.713 699.378 441.011 697.787 440.574 696.892C440.276 696.315 439.661 695.977 439.025 696.116C438.449 696.196 437.992 696.494 437.675 696.971C436.543 698.861 438.111 703.077 438.191 703.315L438.429 703.176L438.191 703.335C438.191 703.335 437.972 703.494 437.992 703.514C438.032 703.574 438.072 703.613 438.131 703.633V703.653ZM438.707 702.301C438.608 702.4 438.529 702.48 438.449 702.579C438.032 701.128 437.536 698.642 438.211 697.528C438.35 697.27 438.608 697.071 438.886 697.011L439.065 696.971C439.601 696.892 439.8 697.111 439.879 697.309C440.296 698.304 439.621 700.77 438.687 702.301H438.707ZM439.164 702.977C440.654 701.386 442.878 699.417 443.99 699.557C444.228 699.576 444.427 699.736 444.526 699.954C444.784 700.352 444.804 700.869 444.606 701.307C444.069 702.202 442.064 702.818 439.164 702.977Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.568 711.11L435.887 704.17L427.368 669.984L413.068 676.945L421.568 711.11Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M413.068 676.945L427.368 670.005L432.233 689.554L417.735 695.778L413.068 676.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.423 701.982L419.145 706.456C418.53 706.576 418.152 707.192 418.271 707.789L420.972 721.71C421.35 723.201 422.859 724.096 424.368 723.738C430.366 722.087 433.147 720.994 440.733 718.965C445.4 717.752 454.715 715.783 460.831 713.099C466.948 710.434 464.148 704.448 461.328 705.045C454.635 706.417 444.526 704.448 439.303 702.161C438.39 701.783 437.377 701.704 436.423 701.962V701.982Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.338 676.488C434.338 676.488 410.129 554.761 405.184 547.502C397.101 535.65 300.144 516.359 300.144 516.359L311.524 514.311L298.357 479.37L212.025 482.771C212.025 482.771 213.833 539.885 222.611 555.198C231.389 570.511 361.273 577.551 369.694 581.011C378.115 584.472 403.913 679.988 403.913 679.988L434.338 676.468V676.488Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M434.338 676.488C434.338 676.488 410.129 554.761 405.184 547.502C397.101 535.65 300.144 516.359 300.144 516.359L311.524 514.311L298.357 479.37L212.025 482.771C212.025 482.771 213.833 539.885 222.611 555.198C231.389 570.511 361.273 577.551 369.694 581.011C378.115 584.472 403.913 679.988 403.913 679.988L434.338 676.468V676.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.409 690.806L438.29 682.155L436.483 667.021L399.504 677.223L404.409 690.806Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M404.409 690.806L438.29 682.155L436.483 667.021L399.504 677.223L404.409 690.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.353 484.103L214.329 483.665L213.793 491.262L240.445 491.898L239.353 484.103Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.206 483.964L244.298 491.839L300.144 491.043L298.337 483.864L243.206 483.964Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.076 485.395L270.811 490.586C270.99 491.859 272.181 492.853 273.492 492.813L282.429 492.535C283.72 492.495 284.633 491.441 284.455 490.168L283.72 484.958C283.541 483.685 282.35 482.691 281.039 482.731L272.102 483.009C270.811 483.049 269.897 484.103 270.076 485.376V485.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.21 482.572H296.232C298.277 482.572 300.005 481.04 300.263 479.032C310.392 399.564 291.048 372.021 291.048 372.021C283.68 369.913 276.173 368.382 268.567 367.447C257.465 366.572 246.324 366.314 235.182 366.731C227.576 366.93 219.989 367.686 212.502 368.979C208.431 370.689 204.399 388.428 208.431 443.633C209.483 458.091 209.662 470.58 209.543 477.898C209.503 480.484 211.608 482.592 214.19 482.592L214.21 482.572Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.549 400.161H295.358L296.55 419.034L288.069 424.542L279.549 420.326V400.161Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M300.263 479.032C300.005 481.061 298.277 482.572 296.232 482.572H214.21C211.628 482.572 209.523 480.464 209.563 477.879C209.662 470.56 209.503 458.072 208.45 443.614C207.874 435.679 207.457 428.5 207.199 422.057C206.524 406.446 206.723 395.011 207.398 386.817C208.391 374.846 210.436 369.854 212.502 368.959C220.009 367.666 227.595 366.911 235.202 366.712C246.323 366.314 257.465 366.553 268.567 367.428C276.173 368.382 283.68 369.914 291.048 372.022C291.048 372.022 310.392 399.565 300.263 479.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.937 365.896L262.43 374.945L263.503 367.348C260.921 362.814 260.265 359.95 262.45 354.68L244.755 334.336C245.231 344.776 243.345 359.015 235.917 365.916L235.937 365.896Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.699 378.883L257.902 381.03L262.45 383.894C262.45 383.894 268.487 418.616 266.799 447.91L271.883 452.086L277.246 447.77C277.246 447.77 270.573 393.957 268.17 383.457L269.202 380.951L271.645 375.741L267.117 373.374L259.967 374.945H254.963L252.679 378.883H252.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M251.964 342.629L262.43 354.68C261.636 356.53 261 358.439 260.543 360.388C256.115 359.055 250.653 353.149 250.872 348.336C250.872 346.388 251.249 344.439 251.964 342.629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.585 361.084C237.585 361.084 247.873 368.263 261.457 373.513C261.457 373.513 263.065 367.487 261.457 362.237L273.154 368.084C273.154 368.084 274.127 377.172 271.426 381.905L262.847 375.621L253.195 383.496C253.195 383.496 234.924 376.437 232.064 366.851L237.585 361.104V361.084Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M297.185 431.721L270.057 453.577C231.171 462.248 214.071 437.966 207.2 422.057C206.524 406.445 206.723 395.011 207.398 386.817C216.732 386.38 228.351 386.38 231.488 388.786C236.95 392.982 255.976 422.395 258.816 424.542C261.676 426.71 297.185 431.721 297.185 431.721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.597 430.588L326.836 425.438L325.089 444.529C325.089 444.529 312.021 446.199 310.412 439.318L312.597 430.588Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.633 429.315L336.449 445.045L325.089 444.548L326.837 425.457L338.633 429.315Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76 392.067L232.978 398.193C234.09 400.281 235.242 402.329 236.433 404.377C238.737 408.474 241.16 412.471 243.662 416.27C246.185 420.028 248.806 423.648 251.507 426.471C252.818 427.903 254.148 429.097 255.221 429.872C255.558 430.131 255.618 430.131 255.717 430.21C255.797 430.31 256.174 430.409 256.393 430.528C256.69 430.648 257.088 430.747 257.425 430.866L258.696 431.185C262.37 432 267.018 432.258 271.645 432.338C276.312 432.418 281.118 432.259 285.944 432.04C295.596 431.543 305.487 430.787 315.218 429.912L317.581 440.889C307.81 444.051 298.039 446.597 287.91 448.506C282.866 449.5 277.722 450.216 272.439 450.773C267.117 451.25 261.755 451.549 255.558 450.873C254.744 450.753 253.99 450.654 253.155 450.495C252.301 450.296 251.487 450.157 250.574 449.898C249.62 449.6 248.786 449.401 247.734 448.943C246.701 448.506 245.628 448.029 244.914 447.611C241.676 445.841 239.154 443.872 236.85 441.864C232.362 437.767 228.747 433.551 225.51 429.176C222.253 424.821 219.354 420.366 216.673 415.852C215.362 413.565 214.091 411.278 212.859 408.971C211.608 406.624 210.476 404.397 209.285 401.772L229.74 392.087L229.76 392.067Z",
    fill: "#B65B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.502 368.959C186.883 378.207 220.108 442.123 234.07 449.282C248.032 456.441 271.665 453.398 271.665 453.398L273.333 431.185C273.333 431.185 261.099 429.693 257.445 428.818C251.646 427.426 239.869 401.693 231.965 387.693C224.061 373.692 212.522 368.939 212.522 368.939L212.502 368.959Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M212.502 368.959C186.883 378.207 220.108 442.123 234.07 449.282C248.032 456.441 271.665 453.398 271.665 453.398L273.333 431.185C273.333 431.185 261.099 429.693 257.445 428.818C251.646 427.426 239.869 401.693 231.965 387.693C224.061 373.692 212.522 368.939 212.522 368.939L212.502 368.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.056 429.634L267.971 455.427L275.319 454.055L277.246 431.006L270.056 429.634Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.314 313.375C291.327 319.321 288.765 330.915 281.317 326.023C273.87 321.131 288.566 303.153 290.314 313.375Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.19 315.504C245.331 330.061 242.908 338.433 248.25 347.601C256.273 361.402 275.716 359.314 282.886 345.871C289.34 333.78 292.935 312.024 280.364 302.776C267.971 293.668 251.07 300.947 248.19 315.504Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.259 299.455L257.723 298.699L258.16 308.165C257.843 307.986 257.505 307.807 257.207 307.628C257.207 307.628 256.154 321.45 248.29 326.163C237.605 318.009 234.487 304.685 241.259 299.435V299.455Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.551 326.003C239.73 329.981 241.736 333.501 244.218 335.668C247.932 338.91 251.944 336.086 252.718 331.472C253.414 327.316 252.321 320.614 247.734 319.162C243.205 317.711 239.353 321.449 239.571 326.003H239.551Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.944 324.989C268.646 326.162 269.004 327.256 269.779 327.455C270.553 327.654 271.407 326.858 271.725 325.685C272.023 324.512 271.665 323.418 270.891 323.219C270.116 323.02 269.262 323.816 268.944 324.989Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.151 328.31C281.853 329.483 282.211 330.577 282.985 330.776C283.76 330.975 284.614 330.18 284.931 329.006C285.229 327.833 284.872 326.739 284.097 326.54C283.323 326.341 282.469 327.137 282.151 328.31Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.802 327.833C277.802 327.833 278.834 334.992 280.959 338.89C278.437 340.203 275.16 338.433 275.16 338.433L277.802 327.833Z",
    fill: "#A02724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.733 341.316C268.19 341.495 268.686 341.674 269.222 341.793C269.421 341.833 269.6 341.734 269.659 341.535C269.719 341.336 269.6 341.157 269.401 341.097C264.257 339.805 262.808 335.628 262.788 335.589C262.728 335.41 262.53 335.31 262.331 335.37C262.152 335.43 262.053 335.628 262.113 335.827C262.172 335.986 263.423 339.586 267.713 341.316H267.733Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.985 319.699C266.223 319.798 266.481 319.759 266.7 319.6C269.182 317.631 271.665 318.406 271.705 318.426C272.082 318.546 272.479 318.347 272.598 317.969C272.717 317.591 272.519 317.193 272.161 317.074C272.022 317.034 268.904 316.04 265.826 318.486C265.508 318.725 265.469 319.182 265.707 319.48C265.786 319.58 265.886 319.659 266.005 319.699H265.985Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.042 325.208C289.162 325.268 289.301 325.268 289.46 325.248C289.837 325.168 290.095 324.791 290.016 324.413C289.241 320.575 286.222 319.381 286.083 319.322C285.726 319.182 285.309 319.361 285.17 319.719C285.031 320.077 285.209 320.495 285.567 320.634C285.686 320.674 288.01 321.629 288.625 324.711C288.665 324.95 288.844 325.148 289.062 325.228L289.042 325.208Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.103 311.168C252.103 311.168 252.46 311.506 253.096 311.864C254.367 312.6 256.73 313.475 259.451 312.123C263.542 310.114 264.833 298.46 276.491 304.387C276.491 304.387 280.483 303.174 283.482 306.853C286.481 310.532 284.415 323.955 290.81 322.106C297.205 320.256 296.093 318.268 296.093 318.268C296.093 318.268 294.305 319.401 293.233 318.506C293.233 318.506 296.589 315.722 294.981 311.804C294.981 311.804 293.432 313.634 292.379 313.276C292.379 313.276 294.325 306.415 290.611 297.148C286.917 287.881 264.178 289.949 264.178 289.949C264.178 289.949 261.318 285.156 251.05 288.497C240.783 291.838 236.096 304.228 237.724 309.617",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.667 443.037L386.198 437.509H325.962L298.238 440.273L297.185 443.037H387.667Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M387.667 443.037L386.198 437.509H325.962L298.238 440.273L297.185 443.037H387.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.962 437.509V443.037H387.667L386.198 437.509H325.962Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.339 410.94C346.08 413.864 348.205 416.25 351.125 416.25H443.394C446.314 416.25 448.896 413.864 449.174 410.94L454.655 351.797C454.715 351.181 454.655 350.604 454.536 350.067C454.02 347.979 452.192 346.487 449.869 346.487H357.599C354.68 346.487 352.098 348.874 351.82 351.797L346.339 410.94Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.339 410.94C346.08 413.864 348.205 416.25 351.125 416.25H443.394C446.314 416.25 448.896 413.864 449.174 410.94L454.655 351.797C454.715 351.181 454.655 350.604 454.536 350.067C454.02 347.979 452.192 346.487 449.869 346.487H357.599C354.68 346.487 352.098 348.874 351.82 351.797L346.339 410.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M351.462 416.25H443.394C446.314 416.25 448.896 413.864 449.174 410.941L454.655 351.798C454.714 351.181 454.655 350.604 454.536 350.067H362.604C359.684 350.067 357.103 352.454 356.825 355.377L351.343 414.52C351.284 415.137 351.343 415.714 351.462 416.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.836 379.977H395.75L400.834 434.705L370.667 439.239V443.037H434.219V439.239L421.211 434.705L414.836 379.977Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M414.836 379.977H395.75L400.834 434.705L370.667 439.239V443.037H434.219V439.239L421.211 434.705L414.836 379.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M395.75 379.977L409.891 442.182L421.211 441.844L414.836 379.977H395.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.201 720.238H353.786C355.037 720.238 356.05 719.224 356.05 717.971V710.593C356.05 709.34 355.037 708.326 353.786 708.326H244.159V472.032H351.919C354.203 472.032 356.07 470.182 356.07 467.875V460.1H238.221C234.924 460.1 232.263 462.764 232.263 466.066V714.292C232.263 717.593 234.924 720.258 238.221 720.258L238.201 720.238Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.201 720.238H353.786C355.037 720.238 356.05 719.224 356.05 717.971V710.593C356.05 709.34 355.037 708.326 353.786 708.326H244.159V472.032H351.919C354.203 472.032 356.07 470.182 356.07 467.875V460.1H238.221C234.924 460.1 232.263 462.764 232.263 466.066V714.292C232.263 717.593 234.924 720.258 238.221 720.258L238.201 720.238Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.077 462.048L223.385 462.048C221.26 462.048 219.532 460.318 219.532 458.19V448.804L531.93 448.804V458.21C531.93 460.338 530.202 462.068 528.077 462.068V462.048Z",
    fill: "#007D87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M219.532 455.427L531.93 455.427V448.804L219.532 448.804V455.427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.998 450.515H538.504C540.569 450.515 542.237 448.844 542.237 446.776C542.237 444.708 540.569 443.037 538.504 443.037H212.998C210.933 443.037 209.265 444.708 209.265 446.776C209.265 448.844 210.933 450.515 212.998 450.515Z",
    fill: "#007D87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_7223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 993,
    height: 741,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSignin);
export default __webpack_public_path__ + "static/media/imgSignin.48f4742d6bb989a8402cd1cadfbd7cf5.svg";
export { ForwardRef as ReactComponent };